import common from './common'
import featuresPay from './feature'

const it = {
    featuresPay,
    common,
    SerialNumberDrawer: {
        productVariants: "Prodotto/Varianti",
        serialNumber: "Numero di Serie",
        noProductsFound: "Nessun prodotto trovato",
        searchByProductSku: "Cerca per prodotto/SKU",
        searchSerialNumbers: "Cerca numeri di serie",
        transactionDetails: "Dettagli Transazione",
        notAvailable: "N/D",
        mainWarehouse: "Magazzino Principale"
    },
    new_build_banner: {
        title: 'Nuova versione:',
        is_available: 'è ora disponibile',
        fallback_title: 'È disponibile una nuova versione dell\'app',
        desc: 'Aggiorna per ottenere le ultime funzionalità e miglioramenti.',
        refreshing: 'Aggiornamento…',
        refresh_now: 'Aggiorna ora',
        later: 'Più tardi',
        you_are_on: "sei su"
    },
    short: {
        finance: 'Finanza',
        stock: 'Magazzino'
    },
    onboarding: {
        welcome: 'Benvenuto!',
        step: {
            product: {
                totalBreakdown: 'Ripartizione totale',
                overallFulfilment: 'Evasione complessiva',
                totalShippedQty: 'Q.tà totale spedita',
                totalReceivedQty: 'Q.tà totale ricevuta',
                totalOrderedQty: 'Q.tà totale ordinata',
                totalShippedOrdered: 'Totale spedito / ordinato',
                totalReceivedOrdered: 'Totale ricevuto / ordinato',
                viewQty: 'Visualizza q.tà',
                fetchingQty: 'Recupero dettagli quantità...',
                noStockInfo: 'Nessuna informazione sullo stock trovata',
                title: '65% Completato',
                description: 'Mancano solo 2 passaggi per iniziare il tuo grande successo!',
                Warehouse: "Magazzino",
            },
            stock: {
                title: '95% Quasi Finito!!',
                description: 'Solo un altro passaggio per iniziare il tuo grande successo! Completa ora.'
            }
        },
        business: {
            title: 'Attività creata con successo!',
            description: 'Fantastico! La tua attività è stata registrata'
        },
        product: {
            title: 'Aggiungi il tuo primo prodotto',
            description: 'Aggiungi un prodotto per iniziare a registrare il magazzino',
            Warehouse: "Magazzino",
        },
        stock: {
            title: 'Prova ad aggiungere magazzino',
            description: 'Inizia a registrare le entrate e le uscite di magazzino'
        },
        action: {
            add_business: {
                title: 'Crea Attività',
                description: 'Vuoi creare una nuova attività? Clicca qui'
            },
            join_business: {
                title: "Unisciti a un'Attività",
                description: 'Hai un codice di invito? Unisciti qui'
            }
        }
    },
    business: {
        title: "Seleziona un'attività, creane una nuova o unisciti",
        add_business: {
            title: 'Crea nuova attività',
            name: "Nome dell'attività",
            name_placeholder: 'Inserisci il nome',
            category: "Categoria dell'attività",
            category_placeholder: 'Seleziona Categoria',
            button: 'Crea Attività'
        },
        edit_business: {
            title: 'Modifica attività'
        },
        join_business: {
            title: "Unisciti a un'Attività",
            input_code: 'Inserisci il codice di invito qui sotto:',
            field_placeholder: 'Codice di invito',
            confirm_title: 'Unisciti',
            confirm_text: 'Diventerai parte del team di '
        },
        no_business: 'Nessuna attività disponibile',
        create_or_join: "Crea o unisciti a un'attività",
        message: {
            saved: 'Attività salvata con successo!'
        },
        settings: {
            isNegativeTransactionDisabled: 'Transazioni di stock negativo',
            isNegativeTransactionDisabledHint: 'Attivando questa opzione, puoi impedire transazioni che risulterebbero in stock negativo.',
            negativeStockError: 'Le transazioni di stock negativo sono disabilitate'
        }
    },
    profile: {
        edit_profile: {
            title: 'Modifica profilo',
            name: 'Nome Completo',
            name_placeholder: 'Inserisci il nome completo',
            email: 'Email',
            phone_number: 'Numero di Telefono'
        },
        message: {
            required_name: 'Il nome è obbligatorio'
        }
    },
    product: {
        weightedAverageCost: 'Costo Medio Ponderato',
        weightedAverageValueLabel: 'Valore Medio Ponderato',
        Product: 'Prodotto',
        hideZeroStock: 'Nascondi stock zero',
        allVariants: 'Tutte le varianti',
        choose_product: 'Scegli Prodotto',
        choose_product_empty: 'Seleziona il prodotto e inserisci la quantità',
        choose_product_empty_manufacturing: 'Seleziona il prodotto e inserisci la quantità di produzione',
        search: {
            placeholder: 'Cerca per nome',
            tooltip: 'Apri scanner',
            Warehouse: "Magazzino",
        },
        column: {
            image: 'Foto',
            name: 'Nome',
            price: 'Prezzo',
            buying_price: 'Prezzo di Costo',
            selling_price: 'Prezzo di Vendita',
            sku: 'SKU',
            stock: 'Magazzino',
            quantity: 'Quantità',
            latest_stock: 'Rimanenza',
            product_deleted: 'Il prodotto è stato eliminato',
            info_not_found: 'Informazioni non disponibili',
            expired_date: 'Data di Scadenza',
            invoice: 'Fattura'
        },
        no_product: 'Nessun Prodotto Disponibile',
        no_product_subtitle: 'Aggiungi il tuo primo produto per iniziare a monitorare scorte, prezzi e vendite.',
        create_first_product: 'Crea il tuo primo prodotto',
        add_product: {
            sku: 'Codice Prodotto',
            sku_placeholder: 'Codice Prodotto. Esempio: 12345',
            name: 'Nome Prodotto',
            name_placeholder: 'Inserisci Nome Prodotto',
            initial_stock: 'Stock Iniziale',
            initial_stock_placeholder: 'Inserisci Stock Iniziale',
            buying_price: 'Prezzo di Costo',
            buying_price_placeholder: 'Inserisci Prezzo di Costo',
            selling_price: 'Prezzo di Vendita',
            selling_price_placeholder: 'Inserisci Prezzo di Vendita',
            category: 'Categoria',
            category_placeholder: 'Seleziona Categoria',
            add_selling_price: "Aggiungi Prezzo all'Ingrosso",
            expired_date: 'Data di Scadenza',
            expired_date_placeholder: 'Seleziona Data',
            description: 'Descrizione',
            description_placeholder: 'Inserisci Descrizione',
            custom_label: 'Attributo',
            custom_label_placeholder: 'Inserisci Chiave',
            add_custom_label: 'Aggiungi Altro Attributo',
            Warehouse: "Magazzino",
        },
        customerLabel: {},
        choose_selling_price: 'Scegli Prezzo di Vendita',
        selling_price: 'Prezzo di Vendita',
        total_product: 'Totale Prodotti',
        total_quantity: 'Totale Magazzino',
        total_buying_price: 'Totale Prezzo di Costo',
        total_selling_price: 'Totale Prezzo di Vendita',
        message: {
            required_name: 'Il nome del prodotto è obbligatorio',
            required_sku: "L'SKU è obbligatorio",
            required_category: "L'SKU è obbligatorio",
            required_quantity: 'Lo stock iniziale è obbligatorio',
            invalid_input_qty: 'Quantità di stock non valida',
            required_buying_price: 'Il prezzo di costo è obbligatorio',
            required_selling_price: 'Il prezzo di vendita è obbligatorio',
            required_selling_price_name: 'Il nome del prezzo di vendita è obbligatorio',
            required_selling_price_price: 'Il prezzo di vendita è obbligatorio'
        },
        viewMore: 'Visualizza Altro',
        WarehouseDetails: 'Dettagli Magazzino',
        WarehouseName: 'Nome Magazzino',
        AddWarehouse: 'Aggiungi Magazzino',
        WarehouseQty: 'Quantità Magazzino',
        Warehouse: 'Magazzino',
        Warehouses: 'Magazzini',
        Variants: 'Varianti',
        VariantName: 'Nome Variante',
        productVariant: 'Varianti Prodotto',
        AddVariant: 'Aggiungi Varianti',
        TranferItem: 'Trasferisci Articoli',
        AddUnit: 'Nuova Unità',
        InitialStkWarehouse: 'Stock iniziale richiesto per aggiungere varianti',
        InitialStockinwarehouse: 'Stock iniziale in magazzino',
        TotalQuantity: 'Quantità Totale:',
        AddNote: 'Aggiungi Nota (Prezzo di Costo)',
        AddNotetitle: 'Aggiungi Nota',
        VariantSuccessMessage: 'Variante prodotto aggiornata con successo',
        Next: 'Avanti',
        Submit: 'Invia',
        INACTIVE: 'INATTIVO',
        errorone: 'Ops! La quantità richiesta per',
        errortwo: 'non corrisponde alle quantità allocate nei magazzini. Regola la quantità o rifornisci.',
        SelectWarehouse: 'Seleziona Magazzino',
        SelectVariant: 'Seleziona Variante',
        Discount: 'Sconto',
        DiscountDetails: 'Dettagli Sconto',
        FinalPrice: 'Prezzo Finale',
        DiscountType: 'Tipo di Sconto',
        DiscountPer: 'Sconto %',
        DiscountValue: 'Valore Sconto',
        Discountonprice: 'Sconto sul prezzo',
        Discountondiscount: 'Sconto sullo sconto',
        AdditionalDiscount: 'Sconto Aggiuntivo',
        SellingPrice: 'Prezzo di Vendita:',
        Save: 'Salva',
        OnOriginalPrice: 'Sul Prezzo Originale',
        OnDiscountedPrice: 'Sul Prezzo Scontato',
        columnSelector: {
            title: 'Mostra colonne',
            columnsButton: 'Colonne',
            costPrice: 'Prezzo di costo',
            sellingPrice: 'Prezzo di vendita',
            sku: 'SKU',
            warehouse: 'Magazzino',
            categories: 'Categorie',
            safetyStock: 'Scorta di sicurezza',
            attributes: 'Attributi',
            notes: 'Note',
            description: 'Descrizione',
            more: 'in più',
            attribute: 'Attributo',
            attributesTitle: 'Attributi',
            categoriesTitle: 'Categorie',
            skuAliases: 'Alias SKU'
        }
    },
    note: {
        title: 'Note',
        add: 'Aggiungi Nota',
        no_note: 'Nessuna nota disponibile'
    },
    settings: {
        category: 'Categoria',
        language: 'Lingua',
        switch_business: 'Cambia Attività',
        currencySelect: 'Valuta',
        languageChangeSuccess: 'Valuta Aggiornata con Successo',
        languageChangeErrorMessage: "Qualcosa è Andato Storto Durante l'Aggiornamento della Valuta",
        currencyAdded: "Valuta aggiunta con successo",
        currencyDelete: "Valuta eliminata con successo",
        Selectyourpreferredlanguage: "Seleziona la tua lingua preferita",
    },
    selectProductStock: 'Seleziona Prodotto',
    category: {
        category_list: {
            title: 'Categorie di Prodotti'
        },
        add_category: {
            button: 'Nuova Categoria',
            title: 'Aggiungi Nuova Categoria'
        },
        edit_category: {
            title: 'Modifica Categoria'
        },
        name: 'Nome Categoria',
        name_placeholder: 'Inserisci Nome Categoria',
        no_category: 'Nessuna categoria disponibile'
    },
    staff: {
        add: 'Aggiungi Personale',
        edit: 'Modifica Personale',
        access: {
            stock: 'Magazzino',
            add_product: 'Aggiungi nuovo prodotto',
            edit_product: 'Modifica prodotto',
            delete_product: 'Elimina prodotto',
            view_capital_price: 'Visualizza Prezzo di Costo',
            add_category: 'Aggiungi nuova categoria',
            edit_category: 'Modifica categoria',
            delete_category: 'Elimina categoria',
            add_supplier: 'Aggiungi nuovo fornitore',
            edit_supplier: 'Modifica fornitore',
            delete_supplier: 'Elimina fornitore',
            add_customer: 'Aggiungi nuovo cliente',
            edit_customer: 'Modifica cliente',
            delete_customer: 'Elimina cliente',
            add_staff: 'Aggiungi personale',
            edit_staff: 'Modifica personale',
            delete_staff: 'Elimina personale',
            change_business_profile: 'Modifica profilo attività',
            access_by_product_category: 'Accesso per categoria di prodotto',
            no_category_message: 'Non hai aggiunto nessuna categoria. Per favore aggiungi una categoria.',
            expenses: 'Spese',
            view_expenses: 'Visualizza spese',
            add_expenses: 'Aggiungi spese',
            edit_expenses: 'Modifica spese',
            delete_expenses: 'Elimina spese',
            warehouse: 'Magazzino',
            add_new_warehouse: 'Aggiungi nuovo magazzino',
            edit_warehouse: 'Modifica magazzino',
            delete_warehouse: 'Elimina magazzino',
            transfer_warehouse: 'Trasferisci magazzino',
            transfer_warehouse_approval: 'Approvazione trasferimento magazzino',
            access_by_warehouse: 'Accesso per magazzino',
            no_warehouse_message: 'Non hai aggiunto alcun magazzino. Aggiungi un elenco di magazzini.',
            purchase_order: "Ordine di acquisto",
            purchase_order_creation: "Creazione ordine di acquisto",
            purchase_order_edit: "Modifica ordine di acquisto",
            purchase_order_cancel: "Annulla ordine di acquisto",
            purchase_order_reopen: "Riapri ordine di acquisto",
            purchase_order_receive: "Ricezione ordine di acquisto",
            sales_order: "Ordine di vendita",
            sales_order_creation: "Creazione ordine di vendita",
            sales_order_edit: "Modifica ordine di vendita",
            sales_order_cancel: "Annulla ordine di vendita",
            sales_order_reopen: "Riapri ordine di vendita",
            sales_order_receive: "Ordine di vendita spedito",
            purchase_order_approval: "Approvazione ordine di acquisto",
            sales_order_approval: "Approvazione ordine di vendita",
            can_do_available_warehouse: "Magazzino disponibile",
            add_batch: "Approvazione creazione lotto"
            ,
            notification: 'Notifica',
            staffNotification: 'Abilita notifica',
            assignee: "Incaricato",
        },
        no_staff: 'Nessun personale disponibile.'
    },
    code: {
        title: 'Nuovo Personale Aggiunto!',
        subtitle: 'Condividi il codice di invito qui sotto per unirti:',
        valid: 'Codice valido solo per 48 ore',
        share: 'Condividi su WhatsApp',
        copied: 'Copiato!',
        invalid: 'Codice non valido!'
    },
    history: {
        no_history: 'Nessuna cronologia.',
        detail: {
            remove: 'Rimuovi Cronologia',
            confirm: 'Questa funzione influirà su magazzino esistente, cronologia e report.'
        },
        no_history_selected: "Nessuna cronologia selezionata",
        select_history_hint: "Fai clic su una cronologia dall'elenco per visualizzare i dettagli",
        select_from_left: "Seleziona dal pannello sinistro",
    },
    supplier: {
        add: {
            title: 'Aggiungi Fornitore'
        },
        edit: {
            title: 'Modifica Fornitore'
        },
        new: 'Nuovo fornitore',
        no_supplier: 'Nessun fornitore disponibile.',
        bank: {
            title: 'Dettagli Bancari'
        },
        note: 'Note',
        form: {
            name: {
                label: 'Nome Fornitore',
                placeholder: 'Inserisci Nome Fornitore',
                placheolder_not_mandatory: 'Inserisci nome',
                error: {
                    required: 'Il nome non può essere vuoto'
                }
            },
            contact: {
                label: 'Numero di Contatto',
                placeholder: '91934554432',
                error: {
                    required: 'Il numero di contatto non può essere vuoto',
                    invalid: 'Numero non valido. Deve includere il codice del paese'
                }
            },
            bank_name: {
                label: 'Nome della Banca',
                placeholder: 'Inserisci Nome della Banca'
            },
            bank_account_name: {
                label: 'Nome del Titolare del Conto',
                placeholder: 'Inserisci Nome del Titolare del Conto'
            },
            bank_account_number: {
                label: 'Numero di Conto',
                placeholder: 'Inserisci Numero di Conto'
            },
            note: {
                label: 'Note',
                placeholder: 'Aggiungi Note'
            },
            openingBalance: {
                addBtn: 'Aggiungi saldo di apertura',
                label: 'Saldo di apertura',
                placeholder: 'Inserisci il saldo di apertura',
                error: {
                    negative: 'Il saldo di apertura non può essere negativo'
                }
            }
        },
        choose: 'Scegli Fornitore'
    },
    customer: {
        add: {
            title: 'Aggiungi Cliente'
        },
        edit: {
            title: 'Modifica Cliente'
        },
        new: 'Nuovo cliente',
        no_customer: 'Nessun cliente disponibile.',
        note: 'Note',
        form: {
            name: {
                label: 'Nome Cliente',
                placeholder: 'Inserisci Nome Cliente',
                placheolder_not_mandatory: 'Inserisci nome',
                error: {
                    required: 'Il nome non può essere vuoto'
                }
            },
            contact: {
                label: 'Numero di Contatto',
                placeholder: '91934554432',
                error: {
                    required: 'Il numero di contatto non può essere vuoto',
                    invalid: 'Numero non valido. Deve includere il codice del paese'
                }
            },
            address: {
                label: 'Indirizzo',
                placeholder: 'Inserisci Indirizzo'
            },
            note: {
                label: 'Note',
                placeholder: 'Aggiungi Note'
            },
            openingBalance: {
                addBtn: 'Aggiungi saldo di apertura',
                label: 'Saldo di apertura',
                placeholder: 'Inserisci il saldo di apertura',
                error: {
                    negative: 'Il saldo di apertura non può essere negativo'
                }
            }
        },
        choose: "Seleziona cliente",
        report: {
            view: 'Visualizza Report Acquirente',
            title: 'Report Cliente',
            no_report: 'Nessun report per gli acquirenti nella data selezionata.',
            column: {
                name: 'Nome',
                total_transaction: 'Transazioni Totali',
                total_amount: 'Vendite Totali',
                total_profit: 'Profitto Totale'
            }
        }
    },
    confirm_delete: 'Sei sicuro di voler eliminare questi dati?',
    report: {
        title: 'Report'
    },
    accounting: {
        download_pdf_report: 'Scarica PDF',
        title: 'Contabilità',
        view_report: 'Visualizza Report Finanziario',
        dashboard_title: 'Report Finanziario',
        stats: 'Statistiche',
        accounting_report: 'Report Contabile',
        filter: {
            date: {
                placeholder: 'Seleziona Data',
                submit: 'Applica',
                cancel: 'Ripristina Filtro'
            },
            timeframe: {
                day: 'Giornaliero',
                week: 'Settimanale',
                month: 'Mensile',
                year: 'Annuale'
            }
        },
        total_sales: 'Vendite Totali',
        total_purchases: 'Acquisti Totali',
        total_profit: 'Profitto Totale',
        total_expenses: 'Spese Totali',
        assets_value: 'Valore Attuale degli Asset',
        total_current_cogs_value: 'Valore Totale Attuale del COGS',
        current_asset_selling_price: 'Prezzo di Vendita del Bene Attuale',
        total_selling_price: 'Prezzo Totale di Vendita',
        table: {
            date: 'Data',
            sales: 'Vendite',
            purchases: 'Acquisti',
            profit: 'Profitto',
            expenses: 'Spese'
        },
        no_data: 'Nessun dato disponibile.'
    },
    stock_report: {
        title: 'Report Magazzino',
        view: 'Visualizza Report Magazzino',
        no_report: 'Nessun record di magazzino per la data o il personale selezionato.',
        allStaffPlaceHolder: 'Tutto il Personale',
        column: {
            total_product: 'Tipi di Prodotto Attuali',
            total_product_quantity: 'Prodotti Attuali Totali'
        }
    },
    subscription: {
        paywall_small: {
            title: 'Funzionalità VIP',
            description:
                'Il periodo di prova per questa funzionalità è terminato. Sostieni lo sviluppo di questa app locale abbonandoti.',
            button: 'Visualizza Piani di Abbonamento'
        }
    },
    payment: {
        order: {
            title: 'Pagamento'
        }
    },

    imageUploadMessage: {
        uploadSize: "La dimensione dell'immagine non deve superare 5MB!",
        failedMessage: "Caricamento dell'immagine del prodotto fallito, riprova!",
        successUpload: "L'immagine è stata caricata con successo!",
        failedUIError: "Eliminazione dell'immagine fallita invito, riprova!",
        SuccessErrorImage: "L'immagine è stata eliminata con successo!"
    },
    productColumns: {
        SKULabel: 'SKU',
        nameLabel: 'Nome Prodotto',
        categoryLabel: 'Categoria',
        BuyingPriceLabel: 'Prezzo di Acquisto',
        SellingLabel: 'Prezzo di Vendita',
        StockLabel: 'Magazzino'
    },
    historyColumns: {
        Transactionlabel: 'Tipo di Transazione',
        Locallabel: 'Ora Locale',
        Createdlabel: 'Creato Da',
        Vendorlabel: 'Nome Fornitore',
        Buyerlabel: 'Nome Acquirente',
        SKUlabel: 'SKU',
        Invoicelabel: 'Fattura',
        Productlabel: 'Nome Prodotto',
        Categorylabel: 'Categoria',
        Buyinglabel: 'Prezzo di Acquisto',
        Sellinglabel: 'Prezzo di Vendita',
        Initiallabel: 'Stock Iniziale',
        Finallabel: 'Stock Finale',
        Stocklabel: 'Variazione Magazzino'
    },
    stockReportColumns: {
        skuLabel: 'SKU',
        productNameLabel: 'Nome Prodotto',
        categoryLabel: 'Categoria',
        buyingPriceLabel: 'Prezzo di Acquisto',
        sellingPriceLabel: 'Prezzo di Vendita',
        stockInLabel: 'Entrata Magazzino',
        stockOutLabel: 'Uscita Magazzino',
        remainingStockLabel: 'Magazzino Residuo',
        openStockLabel: 'Magazzino Iniziale',
        weightedAverageCost: 'Costo Medio Ponderato',
        weightedAverageCostLabel: 'Costo Medio Ponderato',
        weightedAverageValueLabel: 'Valore Medio Ponderato'
    },
    accountingReportColumns: {
        dateRange: 'Intervallo di date',
        reportingPeriod: 'Periodo di rendicontazione',
        reportGenerate: 'Genera report',
        warehouse: 'Magazzino',
        labelDate: 'Data',
        labelSales: 'Vendite',
        labelPurchases: 'Acquisti',
        labelProfit: 'Profitto',
        labelExpenses: 'Spese',
        reportOptions: 'Colonne del rapporto',
        summaryCards: 'Schede di riepilogo',
        grandTotal: 'Totale generale',
        continued: 'cont.',
        subtotal: 'Subtotale',
        page: 'Pagina'
    },
    customerReportColumns: {
        labelName: 'Nome',
        labelTotalTransaction: 'Transazioni Totali',
        labelTotalSales: 'Vendite Totali',
        labelTotalProfit: 'Profitto Totale'
    },
    scannerDialog: {
        finished: 'Completato',
        reduce: 'Riduci',
        successfull: 'Riuscito',
        searching: 'Ricerca in corso...',
        title: 'Scanner attivo. Puntalo sul codice a barre!'
    },
    historyFilter: {
        SelectBuyer: 'Seleziona Acquirente',
        SelectVendor: 'Seleziona Fornitore'
    },
    productStockFilter: {
        StockLowtoHigh: "Magazzino dal Basso all'Alto",
        StockHightoLow: "Magazzino dall'Alto al Basso",
        AlphabetAZ: 'Alfabetico A-Z',
        AlphabetZA: 'Alfabetico Z-A'
    },
    minimizeTitle: 'Scanner attivo',
    security_guarantee: {
        title: 'Sicurezza dei Dati Garantita'
    },
    invoice: {
        invoicePlaceholder: 'Numero Fattura',
        invoiceTitle: 'Fattura',
        manageInvoiceAddress: 'Gestisci indirizzo fattura',
        selectOrManageAddresses: 'Seleziona, modifica o crea indirizzi fattura personalizzati',
        useBusinessProfileAddress: 'Usa indirizzo del profilo aziendale',
        noCustomAddressesFound: 'Nessun indirizzo personalizzato aggiunto',
        createCustomAddressDesc: 'Aggiungi indirizzi di fatturazione o di filiale personalizzati da stampare sulle tue fatture al posto dei dati predefiniti del profilo aziendale.',
        defaultFromBusinessProfile: 'Predefinito dal profilo aziendale',
        editInvoiceAddress: 'Modifica indirizzo fattura',
        createNewInvoiceAddress: 'Crea nuovo indirizzo fattura',
        logoHeaderImage: 'Logo / Immagine intestazione',
        deleteInvoiceAddress: 'Eliminare indirizzo fattura?',
        deleteAddressConfirmText: 'Sei sicuro di voler eliminare questo indirizzo fattura? Questa azione non può essere annullata.'
    },
    ManageInvoiceAddress: 'Gestisci indirizzo fattura',
    SelectOrManageAddresses: 'Seleziona, modifica o crea indirizzi fattura personalizzati',
    UseBusinessProfileAddress: 'Usa indirizzo del profilo aziendale',
    CreateNewAddress: 'Crea nuovo indirizzo',
    UpdatingList: 'Aggiornamento lista...',
    NoCustomAddressesFound: 'Nessun indirizzo personalizzato aggiunto',
    CreateCustomAddressDesc: 'Aggiungi indirizzi di fatturazione o di filiale personalizzati da stampare sulle tue fatture al posto dei dati predefiniti del profilo aziendale.',
    DefaultFromBusinessProfile: 'Predefinito dal profilo aziendale',
    EditInvoiceAddress: 'Modifica indirizzo fattura',
    CreateNewInvoiceAddress: 'Crea nuovo indirizzo fattura',
    LogoHeaderImage: 'Logo / Immagine intestazione',
    UploadingImage: 'Caricamento immagine...',
    UploadImage: 'Carica immagine',
    BusinessName: 'Nome azienda',
    AddressDetails: 'Dettagli indirizzo',
    PhoneNumber: 'Numero di telefono',
    EmailAddress: 'Indirizzo email',
    DeleteInvoiceAddress: 'Eliminare indirizzo fattura?',
    DeleteAddressConfirmText: 'Sei sicuro di voler eliminare questo indirizzo fattura? Questa azione non può essere annullata.',

    stocklowreport: {
        no_stocklowreport_one: 'Nessun articolo con impostazioni di Scorta di Sicurezza.',
        no_stocklowreport_two: 'Aggiungi la quantità di Scorta di Sicurezza.',
        currentStock: 'Scorte attuali',
        safetyStock: 'Scorte di sicurezza',
        pricing: 'Prezzi',
        costPrice: 'Prezzo di costo',
        sellingPrice: 'Prezzo di vendita',
        productInfo: 'Informazioni sul prodotto',
        category: 'Categoria',
        description: 'Descrizione',
        no_description: 'Nessuna descrizione aggiunta',
        variants: 'Varianti',
        unitsOnHand: 'unità disponibili',
        minimumThreshold: 'soglia minima',
        adjust: 'Modifica',
        all: 'Tutti',
        lowStock: 'Scorte basse',
        variantsDetails: 'Dettagli delle varianti',
        qty: 'Qtà',
        addSafetyStock: 'Aggiungi scorte di sicurezza',
        searchByNameSku: 'Cerca per nome/SKU',
        safetyStockShort: 'S',
        warehouseSafetyStock: 'Scorte di sicurezza del magazzino'
    },
    low_alert_stock: 'Inserisci la quantità di scorta di sicurezza',
    lowStockAlertNotify: 'Riceverai una notifica quando il magazzino scenderà sotto la quantità impostata',
    applyButtonStockAlert: 'Applica',
    cancelButtonStockAlert: 'Annulla',
    searchProductLabel: 'Cerca prodotti...',
    successfullyAddedSafetyStock: 'Scorta di Sicurezza aggiornata con successo',
    safety_Stock: 'Scorta di Sicurezza',
    safety_stock_placeholder: 'Inserisci Scorta di Sicurezza',
    lowStockDetailsInfo: {
        ProductCode: 'Codice Prodotto',
        SafetyStock: 'Scorta di Sicurezza',
        Stock: 'Magazzino',
        CostPrice: 'Prezzo di Costo',
        SellingPrice: 'Prezzo di Vendita',
        Category: 'Categoria',
        Description: 'Descrizione',
        ExpirationDate: 'Data di Scadenza'
    },
    CustomLang: {
        Attribute: 'Attributo',
        AddAttribute: 'Aggiungi Attributo',
        EditAttribute: 'Modifica Attributo',
        CustomLabePlaceholder: 'Inserisci Nome Attributo',
        CustomLabePlaceholderSelect: 'Seleziona Tipo',
        AddMoreAttribute: 'Aggiungi Altro Attributo',
        ItemAttribute: 'Attributo Articolo',
        TableName: 'Nome',
        TableType: 'Tipo',
        TableAction: 'Azione',
        TableDelete: 'Elimina',
        TableEdit: 'Modifica',
        deleteMessage: 'Attributo Eliminato con Successo',
        editSuccessMessage: 'Attributo Aggiornato con Successo',
        AddSuccessMessage: 'Attributo Aggiunto con Successo',
        AddAtt: 'Aggiungi',
        EditAtt: 'Modifica',
        SubmitAtt: 'Invio in corso...'
    },
    Expenses: {
        ExpensesTitle: 'Spese',
        AddExpenses: 'Aggiungi Spese',
        ExpenseCategory: 'Categoria di Spesa',
        NoExpenseCategory: 'Nessuna categoria di spesa',
        AddExpenseCategory: 'Aggiungi categoria di spesa',
        SelectExpenseCategory: 'Seleziona categoria di spesa',
        NoExpenses: 'Nessuna Spesa',
        ExpensesSuccess: 'Spese create con successo',
        ExpensesSuccessEdit: 'Spese aggiornate con successo',
        ExpensesCategoryName: 'Nome categoria di spesa',
        ExpensesSuccessDelete: 'Spese eliminate con successo',
        AddNEC: "Aggiungi nuova categoria di spese",
        NC: "Nuova categoria di spese",
        EditNEC: "Modifica categoria di spese"
    },

    Manufacturing: {
        ProducedProduct: "Prodotto finito",
        QuantityManufactured: "Quantità prodotta",
        UnitCost: "Costo unitario",
        RawMaterialsTotal: "Totale materie prime",
        TotalManufacturingCost: "Costo totale di produzione",
        NoRawMaterialsConsumed: "Nessuna materia prima consumata.",
        CostBreakdown: "Dettaglio costi",
        GeneratedBatch: "Lotto generato",
        StoredBinLocation: "Ubicazione stoccaggio",
        NoManufacturingTransactionsFound: "Nessuna transazione di produzione trovata",
        AddManufacture: 'Aggiungi Dettagli di Produzione',
        Manufacturing: 'Produzione',
        RawMaterials: 'Materie Prime',
        AdditonCosts: 'Costi Aggiuntivi',
        RawMaterial: 'Materia Prima',
        AdditonCost: 'Costo Aggiuntivo',
        TotalCost: 'Costo Totale',
        AddRawMaterial: 'Aggiungi materia prima per',
        AddAdditonCost: 'Aggiungi costo aggiuntivo per',
        AddMore: 'Aggiungi altro',
        Add: 'Aggiungi',
        Update: 'Aggiorna',
        Updating: 'Invio in corso...',
        ProductRequired: 'Il prodotto è obbligatorio',
        QuantityRequired: 'La quantità è obbligatoria',
        ChargeRequired: 'Il costo è obbligatorio',
        EstimatedCostRequired: 'Il costo stimato è obbligatorio',
        PurchasePriceRequired: 'Il prezzo di acquisto è obbligatorio',
        SelectCharge: 'Seleziona Costo',
        EstimatedCost: 'Costo Stimato',
        SelectProduct: 'Seleziona un Prodotto',
        Quantity: 'Quantità',
        ManufactureDetails: 'Dettagli di Produzione',
        BuyingPrice: 'Prezzo di Acquisto',
        LabourCharge: 'Costo di Manodopera',
        ElectricityCost: "Costo dell'Elettricità",
        PackagingCharge: 'Costo di Imballaggio',
        LogisticCost: 'Costo Logistico',
        OtherCharges: 'Altri Costi',
        Save: 'Salva dettagli',
        PurchasePrice: 'Prezzo di Acquisto',
        Date: 'Data',
        For: 'Per',
        PurchaseRate: 'Tasso di Acquisto (Prezzo)',
        Scrolltoloadmore: 'Scorri per caricare altro...',
        Noproductsfound: 'Nessun prodotto trovato',
        ManufacturingQuantity: 'Quantità di Produzione',
        ManufactureAddedSuccess: 'Dettagli di produzione aggiornati con successo'
    },
    Warehouses: {
        transferOrder: 'Trasferisci Articoli',
        AddTransferOrder: 'Aggiungi Trasferimento Articoli',
        NewWarehouse: 'Nuovo Magazzino',
        newHead: 'Inizia a gestire più magazzini!',
        headTwo: 'Traccia e gestisci il tuo inventario senza problemi in più magazzini',
        EnableWarehouse: 'ATTIVA MAGAZZINO',
        EnableWarehouse2: 'Attiva Magazzino',
        OrganizationPrimary: "Primario dell'Organizzazione",
        Edit: 'Modifica',
        AreEnableWarehouse: 'Sei sicuro di voler attivare il magazzino?',
        Confirm: 'Conferma',
        Cancel: 'Annulla',
        WarehouseCreatedSuccessfully: 'Magazzino creato con successo',
        MarkAsOP: "Segna come Primario dell'Organizzazione",
        MarkAsInAct: 'Segna come Inattivo',
        MarkAsAct: 'Segna come Attivo',
        MarkedAsInactive: 'Magazzino segnato come inattivo con successo',
        MarkedAsActive: 'Magazzino segnato come attivo con successo',
        MarkedAsOP: 'Magazzino segnato come attivo con successo',
        WareDeletedSuccess: 'Magazzino eliminato con successo',
        SuccessfullyUpdatedWarehouse: 'Magazzino aggiornato con successo',
        SuccessfullyCreatedWarehouse: 'Magazzino creato con successo',
        EditWarehouse: 'Modifica Magazzino',
        AddWarehouse: 'Aggiungi Magazzino',
        WarehouseNameIsRequired: 'Il nome del magazzino è obbligatorio',
        EnterWarehouseName: 'Inserisci il nome del magazzino',
        EnterEmail: 'Inserisci email',
        EnterPhoneNumber: 'Inserisci numero di telefono',
        Location: 'Località...',
        name: 'Nome del magazzino',
        email: 'Email',
        phoneNumber: 'Numero di telefono',
        location: 'Località',
        ViewProducts: 'Visualizza prodotti',
        PageTitle: 'Magazzino',
        noWarehouse: "Nessun magazzino corrisponde alla tua ricerca"
    },
    Assets: {
        headerTitle: 'Asset',
        addAssetMessage:
            'Aggiungi asset qui. Per assegnare un asset al personale, vai al profilo del membro del personale.',
        addAsset: 'Aggiungi Asset',
        editAsset: 'Modifica Asset',
        assetCode: 'Codice Asset',
        assetName: 'Nome Asset',
        assetCategory: 'Categoria Asset',
        assetType: 'Tipo Asset',
        serialNumber: 'Numero di Serie',
        location: 'Località',
        condition: 'Condizione',
        selectCondition: 'Seleziona Condizione',
        fair: 'Discreto',
        good: 'Buono',
        excellent: 'Eccellente',
        poor: 'Scarso',
        notes: 'Note',
        submit: 'Invia',
        submitting: 'Invio in corso',
        noCategory: 'Nessuna categoria',
        selectCategory: 'Seleziona categoria',
        addAssetCat: 'Aggiungi Categoria Asset',
        addAssetCatName: 'Nome categoria asset',
        edit: 'Modifica',
        status: 'Stato',
        createdAt: 'Creato Il',
        viewAsset: 'Visualizza Asset',
        assignAsset: 'Assegna Asset',
        conditionRet: 'Condizione (Al ritorno)',
        searchSelectAssets: 'Cerca/Seleziona Asset',
        assetAssigned: 'Asset assegnato con successo',
        assetReturned: 'Asset restituito con successo',
        selectAnAsset: 'Seleziona un asset',
        action: 'Azione',
        noAssetAssigned: 'Nessun asset assegnato',
        reAssigned: 'Riassegna',
        assignedAssetsList: 'Elenco Asset Assegnati',
        viewHistory: "Visualizza cronologia",
        history: "Cronologia beni",
        loadingHistory: "Caricamento cronologia...",
        loadingMore: "Caricamento di più...",
        dateTime: "Data e ora",
        staff: "Personale",
        AssignedBy: "Assegnato da",
        assign: "ASSEGNA",
        return: "RESTITUISCI",
        unknown: "SCONOSCIUTO",
        noHistory: "Nessuna cronologia disponibile per questo bene.",
        enterReturnNote: "Inserisci una nota per la restituzione",
        returnNote: "Nota di restituzione",
        enterAssignNote: "Inserisci una nota per l'assegnazione",
        assignNote: "Nota di assegnazione",
        AddNAC: "Aggiungi nuova categoria di beni",
        EditNAC: "Modifica categoria di beni",
        others: "Altro"
    },
    LedgerTransaction: {
        ledgerDetails: 'Dettagli Libro Mastro',
        productName: 'Nome Prodotto',
        totalQty: 'Quantità Totale',
        date: 'Data',
        receivedAmt: 'Importo Ricevuto',
        paid: 'Pagato',
        discount: 'Sconto',
        balance: 'Saldo',
        more: 'altro',
        total: 'Totale',
        ledgerupdatedsuccessfully: 'Libro mastro aggiornato con successo',
        ledgeraddedsuccessfully: 'Libro mastro aggiunto con successo',
        viewLedger: 'Visualizza Libro Mastro',
        edit: 'Modifica',
        create: 'Crea',
        Recieved: 'Ricevuto [entrata magazzino]',
        payMode: 'Modalità di Pagamento',
        Refno: 'N. di Riferimento'
    },
    ExtraField: {
        attachment: 'Allegato',
        acceptOnlyImg: 'Accetta solo immagini.',
        addAttribute: 'Aggiungi attributo',
        acceptImgAndDoc: 'Accetta immagini e documenti.'
    },
    phoneInvoiceDownload: {
        Variant: "Variante",
        Warehouse: "Magazzino",
        Bin: "Bin",
        Batch: "Lotto",
        Attributes: "Attributi"
    },
    ImportExcel: {
        ImportStockfromExcel: "Importa Stock da Excel",
        DragDrop: "Trascina e rilascia il tuo file Excel compilato qui o clicca per sfogliare",
        DT: "Scarica Template",
        GB: "Indietro",
        Downloading: "Download in corso...",
        ChangeFile: "Cambia File",
        ReadingExcelfile: "Lettura file Excel...",
        Processing: "Elaborazione...",
        submitUpdateStock: "Invia & Aggiorna Stock",
        downloadLatestTemplate: "Scarica Template Più Recente",
        loginRequired: "Login Richiesto"
    },
    stockForm: {
        recordPaymentNow: "Registra il pagamento ora",
        recordPaymentDescCustomer: "Inserisci quanto ha pagato il cliente",
        recordPaymentDescSupplier: "Inserisci quanto ha pagato il fornitore",
        managePayments: "Gestisci pagamenti",
        invoice: "Fattura",
        challan: "Bolla",
        recordPayment: "Registra pagamento",
        payableAmount: "Importo da pagare",
        paidAmount: "Importo pagato",
        paymentMethod: "Metodo di pagamento",
        paymentDate: "Data di pagamento",
        reference: "Riferimento",
        billId: "Numero fattura",
        importExcel: "Importa da Excel",
        noThanks: "No, grazie",
        checkHistory: "Visualizza cronologia",
        wantViewHistory: "Vuoi visualizzare la cronologia?",
        enterPayable: "Inserisci l'importo da pagare",
        enterPaid: "Inserisci l'importo pagato",
        selectPayment: "Seleziona metodo di pagamento",
        attachment: "Allegato",
        note: "Nota"
    },
    HistoryEdit: {
        products: "Prodotti",
        add_product: "Aggiungi prodotto",
        paidAmountInvalidMessage: "L'importo pagato non può essere superiore all'importo da pagare",
        removingText: "La rimozione di questo prodotto annullerà le modifiche di stock effettuate durante questa transazione.",
        remove: "Rimuovi"
    },
    ExcelProduct: {
        uploadFile: "Carica file",
        dragDrop: "Trascina e rilascia il file Excel o fai clic per caricarlo.",
        parsingFile: "Analisi del file",
        fileSelected: "File selezionato",
        reviewImportedData: "Rivedi i dati importati di seguito. Le colonne vengono abbinate automaticamente quando possibile.",
        changeFile: "Cambia file",
        back: "Indietro",
        invalidFileType: "Carica un file Excel valido (.xlsx o .xls)",
        parseExcelError: "Errore di parsing Excel:",
        noData: "Il file Excel caricato non contiene dati.",
        failedToRead: "Impossibile leggere il file Excel. Riprova.",
        Nodata: "NESSUN_DATO",
        unableToRead: "Impossibile leggere il file.",
        buyingMustNumber: "Il prezzo di acquisto deve essere un numero",
        sellingMustNumber: "Il prezzo di vendita deve essere un numero",
        mustBeNumber: "deve essere un numero",
        bulkUploadfailed: "Caricamento massivo non riuscito",
        importFromExcel: "Importa da Excel",
        generating: "Generazione...",
        downloadTemplate: "Scarica modello",
        uploading: "Caricamento...",
        done: "Fatto",
        requiredField: "{field} è obbligatorio",
        bulkUpload: "Caricamento massivo",
        duplicateSku: "SKU duplicato trovato",
        uploadedSuccessfully: "Tutti i prodotti sono stati caricati con successo!",
        uploadCompleteIssues: "Caricamento completato con problemi",
        uploaded_products: "{count} prodotto(i) caricati.",
        failed_products: "{count} falliti.",
        failed_items: "Elementi non riusciti:"

    },
    Discount: {
        overallDiscount: "Sconto complessivo",
        final: "Totale finale",
        balanceDue: "Saldo dovuto",
        tax: "Imposta"
    },
    ProductForm: {
        barcodeQuantity: "Inserisci quantità codice a barre",
        baseUnit: "Unità base (principale)",
        addSecondaryUnit: "Aggiungere unità secondaria?",
        selectUnit: "Seleziona unità",
        subUnitDetails: "Dettagli dell’unità secondaria",
        subUnit: "Unità secondaria",
        selectSubUnit: "Seleziona unità secondaria",
        conversionRate: "Tasso di conversione",
        exampleLogic: "Logica di esempio:",
        example: "Se vendi penne in scatole, imposta l’unità base come Scatola e aggiungi un’unità secondaria (pezzo) con una conversione di 50. Ciò significa che 1 scatola contiene 50 pezzi.",
        basePrice: "Prezzo base"
    },
    barcode: {
        settings: 'Impostazioni codice a barre',
        labelSize: 'Dimensione etichetta',
        customSize: 'Dimensione personalizzata...',
        widthMm: 'Larghezza (mm)',
        heightMm: 'Altezza (mm)',
        showPrice: 'Mostra prezzo di vendita sull\'etichetta',
        noPrices: 'Nessun prezzo di vendita configurato per questo prodotto.',
        preview: 'Anteprima',
        generate: 'Genera',
        label: 'etichetta',
        singlePage: 'Pagina singola',
        downloadOptions: 'Opzioni di download',
        chooseLayout: 'Scegli il layout per i codici a barre',
        allInSinglePage: 'Aggiungi tutti i codici a barre in una singola pagina.',
        allInA4Grid: 'Tutto in pagina singola',
        allInA4GridSub: 'Dispone tutti i codici a barre in una griglia A4',
        onePerPage: 'Uno per pagina',
        onePerPageSub: 'Ogni codice a barre sulla propria pagina di etichetta'
    },

    TransferItem: {
        transferItem: "Trasferimento articoli",
        Date: "Data",
        Reason: "Motivo",
        enterReason: "Inserisci motivo",
        Name: "Nome",
        QuantityTransfered: "Quantità trasferita",
        SWarehouse: "Magazzino di origine",
        SelectSWarehouse: "Seleziona magazzino di origine",
        DWarehouse: "Magazzino di destinazione",
        SelectDWarehouse: "Seleziona magazzino di destinazione",
        CreatedBy: "Creato da",
        CreatedTime: "Ora di creazione",
        UpdatedTime: "Ora di aggiornamento",
        NoOrderFound: "Nessun ordine trovato",
        New: "Nuovo",
        WarehouseItemTransfer: "Trasferimento articoli di magazzino",
        TotalTransfers: "Trasferimenti Totali",
        EnterReason: "Inserisci motivo",
        ItemDetails: "Dettagli articolo",
        CurrentAvailable: "Disponibilità attuale",
        TransferQty: "Quantità trasferimento",
        SStock: "Stock origine",
        DStock: "Stock destinazione",
        addDescription: "Aggiungi una descrizione",
        selectVariant: "Seleziona variante",
        addNewRow: "Aggiungi nuova riga",
        typeOrSelectItem: "Digita per cercare",
        scrollToLoadMore: "Scorri per caricare altro",
        noProductsFound: "Nessun prodotto trovato",
        selectWarehouse: "Seleziona magazzino"
    },
    Sku: {
        searchSelectProduct: "Cerca / seleziona prodotto",
        searchSelectSku: "Cerca / seleziona SKU",
        noSkuFound: "Nessuno SKU trovato"
    },
    HistoryPage: {
        addFilter: "Aggiungi filtro",
        filtersActive: "Tutti i filtri attivi",
        noProducts: "Nessun prodotto",
        download: "Scarica",
        recentlyUpdated: "Aggiornato di recente",
    },
    StockPage: {
        challanNumber: "Numero challan",
        subTotal: "Subtotale",
        totalTaxes: "Totali e tasse",
        taxInclusive: "Tasse incluse",
        discountedValue: "Valore scontato",
        taxValue: "Valore tassa",
        totalAmount: "Importo totale",
        close: "Chiudi",
        addTax: "Aggiungi tassa",
        label: "Etichetta",
        enterLabel: "Inserisci etichetta",
        taxRate: "Aliquota fiscale",
        enterTaxRate: "Inserisci aliquota fiscale",
        selectTaxRate: "Seleziona aliquota fiscale",
        addNewTax: "Aggiungi nuova aliquota",
        discountProducts: "Valore scontato (Prodotti)",
        taxProducts: "Valore tassa (Prodotti)",
        clickAddPayment: "Clicca per aggiungere pagamento",
        paidGreaterPayable: "L'importo pagato non può superare l'importo dovuto",
        vendorCompulsory: "Il fornitore è obbligatorio per registrare il pagamento",
        customerCompulsory: "È necessario un cliente per registrare il pagamento",
        updateInvoiceFormat: "Aggiorna formato fattura",
        updateChallanFormat: "Aggiorna formato challan",
        addPrefix: "Aggiungi prefisso",
        prefix: "Prefisso"
    },
    EditHistoryPage: {
        search_by_notes: "Cerca per note",
        alertMessage: "Questa modifica è registrata solo nella cronologia e non influisce sullo stock attuale.",
        paymentDetails: "Dettagli pagamento",
        units: "Unità",
        customLabels: "Etichette personalizzate",
        value: "Valore",
        Order_Info: "Informazioni ordine",
        percentage: "Percentuale",
        Stock_updates_on_submit: "Aggiorna lo stock al momento dell'invio",
        Summary: "Riepilogo"
    },
    historyCard: {
        paid: "PAGATO",
        partiallyPaid: "PARZIALMENTE PAGATO",
        billDate: "Data fattura",
        productDetails: "Dettagli prodotto",
        paymentsHistory: "Storico pagamenti",
        updatePayment: "Aggiorna pagamento",
        discounts: "Sconti",
        inclusive: "(incl.)",
        discountOverall: "Valore scontato (Totale)",
        dueAmount: "Importo dovuto",
        enterPaid: "Inserisci importo pagato",
        enterReference: "Inserisci riferimento",
        enterNote: "Inserisci nota",
        enterInvoice: "Inserisci fattura",
        enterChallan: "Inserisci challan",
        edit: "Modificato"
    },
    printInvoice: {
        billTo: "Fatturare a",
        ref: "Rif. n.",
        mode: "Modalità",
        date: "Data",
        amount: "Importo",
        totalPaid: "Totale pagato"
    },
    Contact: {
        supplier_required: "Il fornitore è obbligatorio per l'ingresso di magazzino",
        customer_required: "Il cliente è obbligatorio per l'uscita di magazzino",
        key: "Chiave",
        editHistory: "Modifica cronologia",
        loading: "Caricamento..."
    },
    AW: {
        availablewarehouse: "Magazzino disponibile",
        visibilityManagement: 'Visibilità e gestione',
        availablewarehouses: "Magazzini disponibili",
        Active: "Attivo",
        LWarehouse: "Caricamento magazzini in corso...",
        NWForthisProduct: "Nessun magazzino trovato per questo prodotto.",
        of: "di",
        WarehouseAvailabilty: "Disponibilità magazzino",
    },
    Currency: {
        searchCurrency: "Cerca valute...",
        addCurrency: "Aggiungi valuta",
        addNewCurrency: "Aggiungi nuova valuta",
        editCurrency: "Modifica valuta",
        currencySymbol: "Simbolo della valuta",
        currencyName: "Nome della valuta",
        enterCurrencySymbol: "Inserisci il simbolo della valuta",
        enterCurrencyName: "Inserisci il nome della valuta"
    },
    NewReportLang: {
        DM: "Movimento Giornaliero",
        WR: "Rapporto Magazzino",
        PDM: "Movimento Giornaliero del Prodotto",
        TBP: "Prezzo Totale di Acquisto",
        TPQ: "Quantità Totale di Prodotto",
        TP: "Prodotti Totali",
        CS: "Scorta Attuale",
        IV: "Valore Inventario",
        DA: "Media Giornaliera",
        TSI: "Totale Scorte in Entrata",
        TSO: "Totale Scorte in Uscita",
        TOR: "Tasso di Rotazione",
        Tv: "Valore Totale",
        AST: "Tracciamento SKU Attivo",
        UT: "Unità Tracciate",
        SL: "Livello di Scorta",
        Value: "Valore",
        IO: "ENTRATA/USCITA",
        T: "Rotazione",
        unitsD: "Unità/Giorno",
        Sort: "Ordina",
        Sort_by: "Ordina per",
        Units_available: "Unità disponibili",
        Units_unavailable: "Unità non disponibili",
        Current_assets: "Attività correnti",
        Search: "Cerca",
        available: "Disponibile",
        assigned: "Assegnato",
        AYSWD: "Sei sicuro di voler eliminare?",
        PTS: "Magazzino trasferito con successo",
        AUS: "Asset aggiornati con successo",
        ACS: "Asset creati con successo",
        VSP: "Visualizza prezzo di vendita",
        HUS: "Cronologia aggiornata con successo",
    },
    ReplacementReturn: {
        selectProduct: "Seleziona un prodotto",
        selectReplacementProduct: "Seleziona almeno un prodotto sostitutivo",
        validQuantity: "Inserisci una quantità di reso valida",
        replacedSuccessfully: "Prodotto sostituito con successo",
        returnSuccessfully: "Prodotto restituito con successo",
        failedProcess: "Elaborazione fallita. Riprova.",
        return: "Reso",
        replace: "Sostituisci",
        typeSelectProduct: "Digita o seleziona prodotto...",
        returnQuantity: "Quantità da restituire",
        enterQuantity: "Inserisci quantità",
        replacementDate: "Data di sostituzione",
        returnDate: "Data di reso",
        chooseCustomer: "Scegli cliente",
        additionalNotes: "Aggiungi note aggiuntive...",
        replacementProducts: "Prodotti sostitutivi",
        addProducts: "Aggiungi altri prodotti",
        tapSelect: "Tocca per selezionare dai prodotti disponibili",
        currently: "Attualmente",
        item: "articolo",
        items: "articoli",
        selected: "selezionato",
        selectedItems: "Articoli selezionati",
        hideDetails: "Nascondi ulteriori dettagli",
        showDetails: "Mostra ulteriori dettagli",
        product: "prodotto",
        priceLevel: "Seleziona livello prezzo",
        customPrice: "Inserisci prezzo personalizzato",
        noReplaceHistory: "Nessuna cronologia di sostituzione trovata",
        replaceReturn: "Sostituisci e Restituisci",
        replaceReturnHistory: "Cronologia Sostituzioni e Resi"
    },
    OtherComponent: {
        mfgHistoryTitle: "Cronologia di produzione",
        mfgHistoryDesc: "Traccia i prodotti di magazzino fabbricati",
        dailyOperation: "Operazioni Giornaliere",
        freqUsed: "Azioni usate frequentemente per aggiornare i record rapidamente",
        manageCategory: "Gestisci Categorie",
        organizeCaterory: "Organizza e gestisci categorie di prodotti, spese e beni",
        businessRecord: "Registri Aziendali",
        organizeRecord: "Organizza e gestisci i tuoi registri aziendali",
        trackHistory: "Traccia Cronologia",
        completeTracking: "Cronologia completa per audit e tracciamento",
        Verifyinventorycount: "Verifica conteggio inventario",
        Exchangerates: "Tassi di cambio",
        Productiontracking: "Tracciamento produzione",
        Fixedassetregister: "Registro beni fissi",
        Storagelocations: "Ubicazioni di stoccaggio",
        warehouseAvailability: 'Disponibilità del prodotto a livello di magazzino',
        Logreviewspend: "Registra e rivedi le spese",
        Productgroupings: "Raggruppamenti prodotti",
        Classifyexpenditures: "Classifica spese",
        Assetclassification: "Classificazione beni",
        Manageexchanges: "Gestisci cambi",
        Returnauditlog: "Log audit resi",
        Interlocationmoves: "Spostamenti tra sedi",
        Manageoperationscategoriesrecordsandhistory: "Gestisci operazioni, categorie, record e cronologia"
    },
    no_permission_dialog: {
        title: 'Nessun permesso',
        historyDescription: "Non hai il permesso di visualizzare lo storico delle transazioni. Contatta il tuo amministratore.",
        replacementHistoryDescription: "Non hai il permesso di visualizzare lo storico di sostituzione e reso. Contatta il tuo amministratore.",
        transferHistoryDescription: "Non hai il permesso di visualizzare lo storico dei trasferimenti di magazzino. Contatta il tuo amministratore."
    },
    OthersHistory: {
        title: "Gestisci cronologia",
        transferHistory: "Gestisci cronologia trasferimenti",
        transactionHistory: "Gestisci cronologia transazioni",
        replacementHistory: "Gestisci cronologia sostituzioni e resi"
    },
    catalog: {
        allCategories: "All",
        category: "Category",
        purchaseDescription: "Sfoglia e acquista i prodotti condivisi dall'azienda.",
        description: "Sfoglia i prodotti condivisi dall'azienda.",
        productsAvailable: "Prodotti disponibili",
        noImageAvailable: "Nessuna immagine disponibile",
        productDetails: "Dettagli del prodotto",
        inStock: "disponibile in magazzino",
        availableVariants: "Varianti disponibili",
        options: "opzioni",
        orders: "Ordini"
        ,
        searchProducts: "Cerca prodotti...",
        noProductsFound: "Nessun prodotto trovato",
        tryDifferentKeyword: "Prova a cercare con una parola diversa",
        variants: "Varianti",
        stock: "Scorte",
        cart: "Carrello",
        products: "Prodotti",
        viewCart: "Vedi Carrello",
        backToProducts: "Torna ai Prodotti",
        yourCart: "Il Tuo Carrello",
        clear: "Svuota",
        cartEmpty: "Il tuo carrello è vuoto",
        cartEmptyDesc: "Esplora il catalogo e aggiungi i prodotti che desideri ordinare.",
        browseProducts: "Sfoglia Prodotti",
        selectedItems: "Articoli Selezionati",
        itemInCart: "articolo nel carrello",
        itemsInCart: "articoli nel carrello",
        customerDeliveryDetails: "Dettagli Cliente e Consegna",
        fullName: "Nome Completo",
        enterFullName: "Inserisci il tuo nome completo",
        deliveryAddress: "Indirizzo di Consegna",
        addressPlaceholder: "Via, edificio, città, CAP...",
        orderNote: "Nota Ordine (Opzionale)",
        orderNotePlaceholder: "Istruzioni speciali o note di consegna...",
        paymentMode: "Metodo di Pagamento",
        subtotal: "Subtotale",
        items: "articoli",
        totalAmount: "Importo Totale",
        orderOnWhatsApp: "Ordina su WhatsApp 📲",
        orderPlaced: "Ordine Effettuato con Successo! 🎉",
        orderPlacedDesc: "Il tuo ordine è stato registrato e WhatsApp è stato aperto.",
        continueShopping: "Continua lo Shopping 🛍️",
        cartEmptyTitle: "Carrello Vuoto",
        cartEmptyToast: "Aggiungi prodotti al carrello prima del checkout.",
        incompleteTitle: "Dettagli Incompleti",
        incompleteToast: "Compila tutti i campi obbligatori prima di effettuare l'ordine.",
        nameRequired: "Il nome completo è obbligatorio",
        addressRequired: "L'indirizzo di consegna è obbligatorio",
        catalogUnavailable: "Catalogo Attualmente Non Disponibile",
        catalogUnavailableDesc: "Questo catalogo non è attivo al momento. Contatta l'azienda.",
        invalidCatalogLink: "Link Catalogo Non Valido 🚫",
        invalidCatalogDesc: "Questa pagina del catalogo manca di informazioni richieste.",
        missing: "Mancante",
        catalogSlug: "Slug Catalogo",
        goBackHome: "Torna alla Home",
        inventoryManagement: "Gestione Inventario e Fatturazione 🚀 Simply",
        enter: "Inserisci",
        select: "Seleziona",
        // Catalog Order translations
        catalogOrders: 'Ordini catalogo',
        pending: 'In attesa',
        converted: 'Convertito',
        cancelled: 'Annullato',
        totalRevenue: 'Valore totale',
        totalCatalogOrders: 'Ordini online totali',
        convertToSalesOrder: 'Converti in ordine di vendita',
        date: 'Data',
        status: 'Stato',
        action: 'Azione',
        searchOrders: 'Cerca cliente o telefono...',
        noMatchingOrders: 'Nessun ordine corrispondente',
        noStatusOrders: 'Nessun ordine {status} trovato',
        tryDifferentSearch: 'Prova a cercare con un nome cliente o numero di telefono diverso.',
        noOrdersWithStatus: 'Attualmente non ci sono ordini con stato {status}.',
        noOrdersYet: 'Nessun ordine catalogo',
        noOrdersDescription: 'Gli ordini effettuati dal tuo catalogo online appariranno qui.',
        guestCustomer: 'Cliente ospite',
        item: 'Articolo',
        moreItems: '+{count} altri',
        viewDetails: 'Visualizza dettagli',
        viewSalesOrder: 'Visualizza ordine di vendita',
        cancelOrder: 'Annulla ordine',
        confirmCancelTitle: 'Annullare ordine catalogo?',
        confirmCancelOrder: 'Sei sicuro di voler annullare questo ordine? Questa azione non può essere annullata.',
        keepOrder: 'No, mantieni l\'ordine',
        confirmCancelAction: 'Sì, annulla ordine',
        orderNotFound: 'Ordine catalogo non trovato',
        orderNotFoundDescription: 'Questo ordine non è stato trovato o potresti non avere il permesso di visualizzarlo.',
        backToCatalogOrders: 'Torna agli ordini catalogo',
        placedOn: 'Effettuato il',
        totalItems: 'Articoli totali',
        orderedProducts: 'Prodotti ordinati',
        itemDetails: 'Dettagli articolo',
        quantity: 'Qtà',
        unitPrice: 'Prezzo unitario',
        total: 'Totale',
        variant: 'Variante',
        customerInformation: 'Informazioni cliente',
        additionalFields: 'Campi aggiuntivi',
        fields: 'campi',
    },
    stockNew: {
        Npay: "Nessun prodotto aggiunto ancora",
        emptydesc: "Seleziona un prodotto dal tuo catalogo e inserisci la quantità in entrata per registrare lo stock.",
        tipText: "Suggerimento: Puoi anche caricare un file Excel",
        OT: "Totale Ordine",
        Collapse: "Comprimi"
    },
    deleteBulk: {
        Bulkoperation: "Operazione di massa",
        Applyproducts: "Applica azioni a più prodotti",
        Bulkupload: "Caricamento di massa",
        ImportCSVfile: "Importa prodotti tramite file Excel o CSV",
        or: "o",
        Bulkdelete: "Eliminazione di massa",
        Permanentlyallproducts: "Rimuovi permanentemente tutti i prodotti",
        IrrText: "L'eliminazione di massa è irreversibile. Esporta prima un backup se necessario.",
        SeP: "Prodotti selezionati",
        sP: "Seleziona prodotto",
        DA: "Elimina tutto",
        DP: "Elimina prodotti",
        sL: "Seleziona tutto",
        ASDE: "Sei sicuro di voler eliminare tutti i prodotti tranne",
        ASDAllP: "Sei sicuro di voler eliminare tutti i prodotti?",
        ASD: "Sei sicuro di voler eliminare",
        products: "prodotti",
        TACBU: "Questa azione non può essere annullata.",
        LP: "Caricamento prodotti...",
        FM: "Caricamento di più...",
        NPF: "Nessun prodotto trovato.",
        LMP: "Caricamento altri prodotti..."
    },
    NewVariantModal: {
        Definevariantsassign: "Definisci varianti e assegna quantità",
        Nothingallocated: "Niente assegnato",
        Overallocated: "Sovra-assegnato",
        Fullyallocated: "Assegnato completamente",
        Overby: "Eccesso di",
        Allvariantsneedaname: "Tutte le varianti necessitano di un nome.",
        Reducequantities: "Riduci quantità.",
        Overallocatedby: "Sovra-assegnato di",
        Quantitiesmustmatchthetotalavailability: "Le quantità devono corrispondere alla disponibilità totale.",
        Allocatequantitiesacrosswarehouses: "Assegna quantità tra magazzini",
        Notfullydistributed: "Non completamente distribuito:",
        remaining: "rimanente",
        Qty: "Qtà",
        Inactive: "Inattivo",
        left: "rimanente"
    },
    ProductFormNew: {
        BasicInfo: "Informazioni di base",
        ProductImage: "Immagine del prodotto",
        Images: "Immagini",
        Pricing: "Prezzi",
        Everypriceneedsbothalabelandanamount: "Ogni prezzo richiede un'etichetta e un importo",
        AddalabellikeWholesaleorRetailtoidentifythisprice: 'Aggiungi un\'etichetta come "All\'ingrosso" o "Al dettaglio" per identificare questo prezzo',
        AddMultiplePrice: "Aggiungi prezzi multipli",
        NoPhotosLetAiFind: "Niente foto? Lascia che l'IA trovi le immagini del prodotto",
        AddProductImagesTitle: "Aggiungi immagini del prodotto",
        ChooseHowToAddPhotos: "Scegli come desideri aggiungere foto per questo prodotto:",
        SearchWithAi: "Cerca con l'IA",
        SearchWithAiDesc: "Trova e seleziona automaticamente le immagini del prodotto usando l'IA",
        FilesFileExplorer: "File (Esplora file)",
        FilesFileExplorerDesc: "Scegli le immagini direttamente dal tuo computer",
        AiProductImageFinder: "Ricerca immagini prodotto IA",
        AiProductImageFinderDesc: "Cerca e seleziona immagini per il tuo prodotto",
        TypeProductNamePlaceholder: "Digita il nome del prodotto...",
        SearchForYourProduct: "Cerca il tuo prodotto",
        SearchForYourProductHint: `Prova il nome di un marchio o di un prodotto, es. "Kirkland Minoxidil"`,
        ImagesSelected: "immagini selezionate",
        AddSelected: "Aggiungi selezionate"
    },
    AttributeNewCustom: {
        Defineanewcustomfield: "Definisci un nuovo campo personalizzato",
        AttributeName: "Nome attributo",
        DataType: "Tipo di dato",
        Noattributesfound: "Nessun attributo trovato",
        ManageAttributes: "Gestisci attributi",
        Editordeleteexistingattributes: "Modifica o elimina attributi esistenti",
        UpdateAttribute: "Aggiorna attributo",
        Saving: "Salvataggio in corso..."
    },
    NewExpenses: {
        Noexpensesyet: "Nessuna spesa ancora",
        Addyourfirstexpensetostarttrackingyourspending: "Aggiungi la tua prima spesa per iniziare a monitorare le tue uscite.",
        TOTALEXPENSES: "SPESE TOTALI",
        ENTRIES: "VOCI",
        BYCATEGORY: "PER CATEGORIA",
        Nocategoriestodisplay: "Nessuna categoria da mostrare",
        DateanfTime: "Data e ora"
    },
    PurchaseSales: {
        CancelOrder: "Annulla ordine",
        ReopenOrder: "Riapri ordine",
        Reopen: "Riapri",
        ConfirmCancelOrder: "Sei sicuro di voler annullare questo ordine?",
        ConfirmReopenOrder: "Sei sicuro di voler riaprire questo ordine?",
        OrderCancelledSuccessfully: "Ordine annullato con successo.",
        OrderReopenedSuccessfully: "Ordine riaperto con successo.",
        CancelledBy: "Annullato da",
        Cancelled: "Annullato",
        ConvertPriceBasedOnUnitConversion: "Converti prezzo in base alla conversione dell'unità",
        MarkPaymentAsPending: "Contrassegna il pagamento come in sospeso",
        PendingReceivableDesc: "L’importo verrà registrato come credito. Registra il pagamento alla ricezione.",
        PendingPayableDesc: "L’importo verrà registrato come debito. Registra il pagamento al saldo.",
        SelectCustomerFirst: "Seleziona prima un cliente",
        SelectSupplierFirst: "Seleziona prima un fornitore",
        SelectItemsFirst: "Seleziona prima almeno un articolo",
        PaymentMarkedPendingDesc: "Il pagamento è contrassegnato come in sospeso. Deseleziona 'Contrassegna il pagamento come in sospeso' per registrare il pagamento ora.",
        SelectCustomerAndItemFirst: "Seleziona prima un cliente e almeno un articolo",
        SelectSupplierAndItemFirst: "Seleziona prima un fornitore e almeno un articolo",
        SelectCustomerProductFirst: "Seleziona prima cliente e prodotto",
        SelectSupplierProductFirst: "Seleziona prima fornitore e prodotto",
        Receivables: "Crediti",
        Payables: "Debiti",
        AccessDenied: "Accesso negato",
        YouDonthaeP: "Non hai i permessi per visualizzare questa pagina. Se pensi sia un errore, contatta il tuo amministratore.",
        purchase: "Acquisto",
        sales: "Vendite",
        Areyousureyouwantto: "Sei sicuro di voler",
        Thisactionwillupdateitsstatus: "Questa azione aggiornerà il suo stato.",
        ReasonOPtional: "Motivo (opzionale)",
        Enterareasonfor: "Inserisci un motivo per",
        optionalDot: "(opzionale)...",
        Reject: "Rifiuta",
        ConfirmOrder: "Conferma ordine",
        RejectOrder: "Rifiuta ordine",
        Previous: "Precedente",
        First: "Primo",
        Order: "Ordine",
        Items: "Articoli",
        Memo: "Memo",
        SelectDateRange: "Seleziona intervallo date",
        List: "Elenco",
        Board: "Bacheca",
        View: "Visualizza",
        CreateSalesOrder: "Crea ordine di vendita",
        CreatePurchaseOrder: "Crea ordine di acquisto",
        successfully: "con successo",
        ManageAttachments: "Gestisci allegati",
        Stockoutitemsimmediatelyaftersaving: "Scarica articoli dal magazzino subito dopo il salvataggio.",
        Stockinitemsimmediatelyaftersavingthisorder: "Carica articoli in magazzino subito dopo il salvataggio di questo ordine.",
        ViewAttachments: "Visualizza allegati",
        MemoAttachments: "Memo e allegati",
        ReceivedDate: "Data di ricezione",
        ShippedDate: "Data di spedizione",
        OrderDate: "Data ordine",
        OrderDetails: "Dettagli ordine",
        Subtotal: "Subtotale",
        OrderSummary: "Riepilogo ordine",
        AddItem: "Aggiungi articolo",
        NewSalesOrder: "Nuovo ordine di vendita",
        NewPurchaseOrder: "Nuovo ordine di acquisto",
        Createandmanageyour: "Crea e gestisci i tuoi",
        orders: "ordini",
        Removeitem: "Rimuovi articolo",
        UnitPrice: "Prezzo unitario",
        PurchaseOrder: "Ordine di acquisto",
        SalesOrder: "Ordine di vendita",
        PurchaseInvoice: "Fattura di acquisto",
        SalesInvoice: "Fattura di vendita",
        PurchaseOrdernotfound: "Ordine di acquisto non trovato",
        Approve: "Approva",
        MarkasShipped: "Segna come spedito",
        MarkasReceived: "Segna come ricevuto",
        Marking: "Segnatura in corso...",
        PartiallyShip: "Spedizione parziale",
        PartiallyReceive: "Ricezione parziale",
        Deleting: "Eliminazione in corso...",
        Transaction: "Transazione",
        Details: "Dettagli",
        Item: "Articolo",
        Received: "Ricevuto",
        Shipped: "Spedito",
        Ordered: "Ordinato",
        units: "unità",
        Overalldiscount: "Sconto complessivo",
        Transactions: "Transazioni",
        Notransactionsfound: "Nessuna transazione trovata",
        OrderedQty: "Qtà ordinata",
        Totalqty: "Qtà totale",
        StockingOut: "Scarico magazzino...",
        StockingIn: "Carico magazzino...",
        thiorderUpdateStuau: "questo ordine? Questa azione aggiornerà il suo stato.",
        TransactionDetails: "Dettagli transazione",
        Fetchingtransactiondetails: "Recupero dettagli transazione...",
        Nodetailsfoundforthistransaction: "Nessun dettaglio trovato per questa transazione.",
        TotalBreakDown: "Ripartizione totale",
        ChangeAmount: "Importo di resto",
        Attachments: "Allegati",
        PoNumber: "Numero PO",
        SoNumber: "Numero SO",
        partner: "Partner",
        EditPurchase: "Modifica acquisto",
        EditSales: "Modifica vendita",
        PurchaseOrderDetails: "Dettagli ordine di acquisto",
        SalesOrderDetails: "Dettagli ordine di vendita",
        OrderType: "Tipo di ordine",
        SelectOrderType: "Seleziona tipo di ordine",
        OrderTypePrepaid: "Prepago",
        OrderTypeCOD: "Pagamento alla consegna",
        OrderTypePayLater: "Paga più tardi",
        OrderTypePartialPayment: "Pagamento parziale",
        OrderTypeSubscription: "Abbonamento",
        viewAvailabilty: 'Visualizza disponibilità',
        NotReceived: "Non ricevuto",
        NotShipped: "Non spedito",
        PartiallyReceived: "Parzialmente ricevuto",
        PartiallyShipped: "Parzialmente spedito",
    },
    PriceReference: {
        HighPrice: "Prezzo Alto",
        LowPrice: "Prezzo Basso",
        LastPrice: "Ultimo Prezzo",
        LastPurchasePrice: "Ultimo prezzo di acquisto",
        Nopricerecordsfound: "Nessun record di prezzo trovato",
        BuyingPriceReference: "Riferimento Prezzo di Acquisto",
        SellingPriceReference: "Riferimento Prezzo di Vendita",
        Viewstockinpricesfortheselectedvendorandproduct: "Visualizza prezzi di ingresso magazzino per il fornitore e prodotto selezionati",
        Viewstockoutpricesfortheselectedcustomerandproduct: "Visualizza prezzi di uscita magazzino per il cliente e prodotto selezionati"
    },
    SubscriptionLocale: {
        premiumPlan: "Piano Premium",
        heading: "Prendi decisioni aziendali",
        headingHighlight: "Basate sui dati",
        subtitle: "Sblocca tutta la potenza delle tue analytics aziendali — senza limiti, senza compromessi.",
        choosePlan: "Scegli il tuo piano",
        monthly: "Mensile",
        annual: "Annuale",
        oneTime: "Una Tantum (Mensile)",
        perMonth: "al mese",
        perYear: "all'anno",
        bestValue: "Miglior valore",
        continueWith: "Continua con",
        perMonthShort: "mese",
        perYearShort: "anno",
        troubleWithSubscription: "Problemi con l'abbonamento?",
        contactUs: "Contattaci",
        paymentNotReady: "Pagamento non pronto",
        checkoutError: "ERRORE CHECKOUT",
        pricePreviewError: "ERRORE ANTEPRIMA PREZZO",
        subNotAvailable: "Abbonamento non disponibile",
        subNotAvailableDesc: "Gli abbonamenti web non sono attualmente disponibili nel tuo paese. Iscriviti tramite la nostra app mobile o contattaci direttamente per assistenza."
    },
    SubscriptionLocale2: {
        GoPro: "Passa a Pro",
        Makesmarterdecisionsbackedbyrealbusinessdata: "Prendi decisioni più intelligenti supportate da dati aziendali reali",
        ExploreProPlans: "Esplora i piani Pro"
    },
    emptyWarehouseState: {
        tips: [
            "Puoi avere più magazzini per diverse ubicazioni fisiche",
            "Ogni prodotto traccia lo stock per magazzino in modo indipendente",
            'Usa "Trasferisci Magazzino" per spostare lo stock tra le ubicazioni'
        ],
        NoWarehousesConfigured: "Nessun Magazzino Configurato",
        desc: "Inizia aggiungendo i tuoi magazzini (se ne hai più di uno), poi procedi ad aggiungere prodotti e registrare i movimenti di stock.",
        WarehouseSetupTips: "Suggerimenti per la Configurazione del Magazzino",
        Noproductselected: "Nessun prodotto selezionato",
        Selectaproductfromthelefttoviewlowstockdetails: "Seleziona un prodotto da sinistra per visualizzare i dettagli dello stock basso.",
        Chooseaproductfromthelist: "Scegli un prodotto dalla lista",
        SelectProduct: "Seleziona Prodotto",
        SetQuantity: "Imposta Quantità",
        Showing: "Visualizzando",
        products: "prodotti",
        Continue: "Continua",
        SaveSafetyStock: "Salva Stock di Sicurezza",
        SafetyStockSaved: "Stock di Sicurezza Salvato!",
        hasbeensetto: "è stato impostato a",
        AddAnother: "Aggiungi un altro",
        Chooseaproduct: "Scegli un prodotto",
        Step: "Passo",
        of: "di",
        Setsafetyquantity: "Imposta quantità di sicurezza",
        Complete: "Completato",
        SafetyStockQuantity: "Quantità Stock di Sicurezza",
        Minimumunitsdropsbelowthisnumber: "Unità minime da mantenere sempre in stock. Un avviso viene attivato quando lo stock scende sotto questo numero.",
        NewSafetyStock: "Nuovo Stock di Sicurezza",
        SafetyNow: "Sicurezza Ora",
        SettingTo: "Impostazione a",
        Change: "Modifica",
        sell: "vendere",
        cost: "costo",
        BulUD: "Caricamento/Eliminazione Massiva"
    },
    SimplyLoginUI: {
        sslEncryption: "Crittografia SSL a 256 bit",
        dataPrivate: "I tuoi dati sono 100% privati",
        worksOnDevices: "Funziona su Android e iPhone",
        realTimeSync: "Sincronizzazione in tempo reale su tutti i dispositivi",
        cloudBackup: "Backup automatico sul cloud",
        availableOn: "Disponibile su Web, Android e iOS",
        tagline: "Il tuo inventario,",
        taglineEm: "bellamente semplice.",
        subtitle: "Accedi per gestire lo stock, tracciare le vendite e far muovere il tuo business — tutto in un unico posto.",
        feature1Title: "Tracciamento stock in tempo reale",
        feature1Desc: "Sai esattamente cosa c'è in ogni magazzino, sempre aggiornato.",
        feature2Title: "Ordini di vendita e acquisto",
        feature2Desc: "Crea fatture, gestisci fornitori e traccia ogni transazione.",
        feature3Title: "Report intelligenti",
        feature3Desc: "Report finanziari, di stock e movimenti giornalieri a colpo d'occhio.",
        feature4Title: "Sincronizzazione in tempo reale su tutti i dispositivi",
        feature4Desc: "Le modifiche sul telefono appaiono istantaneamente sul web — e viceversa.",
        rating1: "Valutato",
        rating2: "4.9/5",
        rating3: "da 10.000 aziende all'ingrosso",
        brandName: "Simply",
        greeting: "Ciao di nuovo! 👋",
        noPasswordNeeded: "Accedi per accedere al tuo inventario — Android, iPhone e web, tutto sincronizzato.",
        badge1: "Gestione Stock",
        badge2: "Tracciamento Vendite",
        badge3: "Report",
        trustEncryptedTitle: "Crittografato",
        trustEncryptedSub: "SSL 256-bit",
        trustPrivateTitle: "Privato",
        trustPrivateSub: "Solo i tuoi dati",
        trustBackedTitle: "Salvaguardato",
        trustBackedSub: "Backup automatico giornaliero",
        availableOnLabel: "DISPONIBILE SU",
        platformAndroid: "Android",
        platformIphone: "iPhone",
        platformWeb: "Web",
        syncBadge: "Tutti i dispositivi si sincronizzano istantaneamente in tempo reale",
        securityNote: "100% sicuro.",
        securityDesc: "Crittografia di livello bancario protegge tutti i tuoi dati. Leggiamo solo il tuo nome e la tua email — nient'altro, mai.",
        signingIn: "Accesso in corso…",
        termsPrefix: "Accedendo accetti i",
        privacyPolicy: "Informativa sulla Privacy",
        and: "e",
        termsOfService: "Termini di Servizio",
        google: "Accedi con Google"
    },
    BatchLocal: {
        BatchName: "Nome Lotto",
        EnterBatchName: "Inserisci nome lotto",
        EnterNotes: "Inserisci note",
        ExpiredDate: "Data di scadenza",
        Selectexpireddate: "Seleziona data di scadenza",
        BatchStatus: "Stato Lotto",
        CreatedDate: "Data di creazione",
        Areyousureyouwanttodeletethisbatch: "Sei sicuro di voler eliminare questo lotto?",
        Youhavencreatedanybatchforthisproduct: "Non hai ancora creato alcun lotto per questo prodotto.",
        Createyourfirstbatchtostarttrackingtockbylotexpiry: "Crea il tuo primo lotto per iniziare a tracciare lo stock per lotto e scadenza.",
        Nobatchesyet: "Ancora nessun lotto",
        Whatisbatchmanagement: "Cos'è la gestione dei lotti?",
        Howithelpsyourbusiness: "Come aiuta la tua azienda",
        Trackbylotnumber: "Traccia per numero di lotto",
        Trackbylotnumberdesc: "Raggruppa lo stock per lotto del produttore in modo da sapere sempre da quale lotto proviene un'unità.",
        Expirydatecontrol: "Controllo data di scadenza",
        Expirydatecontroldesc: "Ricevi avvisi prima che lo stock scada. Vendi prima i lotti più vecchi e riduci gli sprechi automaticamente.",
        Fulltraceability: "Tracciabilità completa",
        Fulltraceabilitydesc: "Vedi esattamente quale lotto è stato usato in ogni transazione — ideale per audit e richiami.",
        Supplierwisestock: "Stock per fornitore",
        Supplierwisestockdesc: "Separa lo stock da fornitori diversi anche per lo stesso prodotto. Confronta la qualità lotto per lotto.",
        Createyourfirstbatchbutton: "Crea il tuo primo lotto",
        Nomatchesfound: "Nessuna corrispondenza trovata",
        NomatchesfounddescBefore: "Non abbiamo trovato alcun lotto corrispondente a ",
        NomatchesfounddescAfter: "",
        Clearsearch: "Cancella ricerca",
        Nohistoryfoundthisbatch: "Nessuna cronologia trovata per questo lotto",
        ComprehensiveDetails: "Dettagli completi",
        History: "Cronologia",
        InBatch: "Nel Lotto",
        Noproductfoundinthisbatch: "Nessun prodotto trovato in questo lotto",
        SelectBatch: "Seleziona Lotto",
        available: "disponibile",
        Searchbatches: "Cerca lotti...",
        Expires: "Scade",
        Nobatchesfound: "Nessun lotto trovato",
        ManageBatches: "Gestisci Lotti",
        Batchmanagement: "Gestione Lotti",
        Trackstockexpiry: "Traccia stock per lotto e scadenza",
        Turnoffbatchmanagement: "Disattivare la gestione dei lotti?",
        Yourgsafe: "I tuoi dati lotto esistenti rimangono sicuri.",
        Reenableanytimefrom: "Puoi riattivarla in qualsiasi momento da",
        Otherstab: "scheda Altro",
        AddBatch: "Aggiungi Lotto",
        Total: "Totale",
        AssignProduct: "Assegna Prodotto",
        EditProductAssignment: "Modifica assegnazione prodotto",
        AssignProducttoBatch: "Assegna prodotto al lotto",
        Updateproductconfiguration: "Aggiorna configurazione prodotto",
        Step1of2: "Passo 1 di 2",
        Step2of2: "Passo 2 di 2",
        Selectvariantwarehouse: "Seleziona variante e magazzino",
        SelectedProduct: "Prodotto selezionato",
        AssignQuantity: "Assegna quantità",
        BatchInfo: "Informazioni sul Lotto",
        Wecouldnthisproductidentifier: "Non abbiamo trovato lotti associati a questo identificatore di prodotto.",
        NoActiveBatches: "Nessun Lotto Attivo",
        Endofresults: "Fine dei risultati",
        Expiry: "Scadenza",
        BatchManagementDescription: "Monitora le scorte per numero di lotto e data di scadenza. Garantisce l'ordine LIFO / FEFO corretto in ogni operazione di uscita merce — senza necessità di selezione manuale.",
        Expiryalerts: "Avvisi di scadenza",
        Autonotifications: "Notifiche automatiche",
        LIFOsorting: "Ordinamento LIFO / FEFO",
        Smartstockflow: "Flusso scorte intelligente",
        Perout: "Uscita merce per lotto",
        Precisiontracking: "Tracciamento di precisione",
        NeedsReview: "Richiede revisione",
        Pending: "In sospeso",
        Rejected: "Rifiutato",
        Approved: "Approvato",
        WaitingForApproval: "In attesa di approvazione",
        WaitingForApprovalDesc: "Il tuo proprietario esaminerà e approverà questo lotto a breve.",
        BatchRejected: "Lotto rifiutato",
        BatchRejectedDesc: "Il tuo proprietario ha rifiutato questo lotto.",
        Reason: "Motivo",
        Approve: "Approva",
        Reject: "Rifiuta",
        ConfirmApproveTitle: "Approva lotto",
        ConfirmRejectTitle: "Rifiuta lotto",
        ConfirmApprovalAction: "Sei sicuro di voler {action} questo lotto? Questa azione aggiornerà il suo stato.",
        ReasonOptional: "Motivo (Opzionale)",
        EnterReasonPlaceholder: "Inserisci un motivo per {action} (opzionale)",
        Processing: "Elaborazione in corso...",
        BatchActivatedSuccess: "Lotto attivato con successo",
        BatchDeactivatedSuccess: "Lotto disattivato con successo",
        BatchDeletedSuccess: "Lotto eliminato con successo",
        BatchApprovedSuccess: "Lotto approvato con successo",
        BatchRejectedSuccess: "Lotto rifiutato con successo",
        SearchByBatchName: "Cerca per nome lotto...",
        YesTurnOff: "Sì, disattiva",
        KeepItOn: "Mantieni attivo"
    },
    CategoryNewL: {
        TotalCategories: "Totale categorie",
        lastaddedcategory: "Ultima categoria aggiunta",
        acrossalltypes: "in tutti i tipi",
        MostRecent: "Più recente",
        YesD: "Sì, elimina",
        AllAssociated: "Tutti i prodotti associati potrebbero essere interessati"
    },
    OverDas: {
        movestockbetweenlocations: "Sposta stock",
        no_activity_yet: "Nessuna attività ancora",
        no_activity_sub: "Vendite, acquisti, movimenti di stock e resi appariranno qui in tempo reale.",
        make_first_sale: "Effettua la prima vendita",
        add_stock: "Aggiungi stock",
        all_stock_healthy: "Tutti i livelli di stock sono sani",
        all_stock_healthy_sub: "Nessun articolo è in esaurimento. Imposta soglie minime sui prodotti per ricevere avvisi qui.",
        set_stock_thresholds: "Imposta soglie di stock",
        no_warehouses_setup: "Nessun magazzino configurato",
        no_warehouses_setup_sub: "Aggiungi un magazzino per iniziare a tracciare dove è conservato il tuo stock e gestire le sedi.",
        add_first_warehouse: "Aggiungi il primo magazzino",
        Customer: "Clienti",
        PurchasevsSales: "Acquisti vs Vendite",
        Financialperformancechart: "Grafico delle prestazioni finanziarie",
        QuickActions: "Azioni rapide",
        Frequentlyused: "Usate frequentemente",
        Addinventory: "Aggiungi inventario",
        Dispatchitems: "Spedisci articoli",
        Addorder: "Aggiungi ordine",
        Newitem: "Nuovo articolo",
        Inventoryaccess: "Accesso all'inventario",
        Itemsneedingreorder: "Articoli che necessitano di riordino",
        Latesttransactions: "Ultime transazioni",
        Operationalsummary: "Riepilogo operativo",
        ViewAll: "Vedi tutto",
        Manage: "Gestisci",
        RecentActivity: "Attività recente",
        LowStockAlerts: "Avvisi stock basso",
        Primary: "Principale",
        TotalWarehouses: "Totale magazzini"
    },
    SerialLocal: {
        ShowOrHideFields: "Mostra o nascondi campi",
        ShowOrHideFieldsDesc: "Tocca qualsiasi elemento qui sotto per includerlo o rimuoverlo dalla fattura stampata. Le modifiche vengono applicate immediatamente.",
        Manufacturesettings: "Impostazioni di produzione",
        Showbuyingprice: "prezzo d'acquisto / costo del prodotto",
        Showadditionalcost: "costo aggiuntivo",
        Costbreakdown: "Ripartizione dei costi",
        Unitcost: "Costo unitario",
        Rawmaterialstotal: "Totale materie prime",
        Confirmentry: "Conferma inserimento",
        SaveSerials: "Salva numeri di serie",
        SerialNumber: "Numero di serie",
        selected: "selezionato",
        added: "aggiunto",
        Serialnumbers: "Numeri di serie",
        ResetAll: "Reimposta tutto",
        Wecouldnfindthis: "Non abbiamo trovato numeri di serie disponibili per questo prodotto.",
        Nounitsfound: "Nessuna unità trovata",
        Searchingserialnumbers: "Ricerca numeri di serie...",
        Scanorenterstock: "Scansiona o inserisci numeri di serie per nuovo stock",
        Whataserialnumber: "Cos'è un numero di serie?",
        Auniqueidentifieryourinventorylifecycle: "Un identificatore univoco per unità — ti permette di tracciare ogni singolo articolo durante tutto il ciclo di vita dell'inventario.",
        Trackedstockout: "Uscita stock tracciata",
        Chooseexactlyselected: "Scegli esattamente quali numeri di serie stanno uscendo. Vengono mostrati solo i seriali caricati in stock per questo prodotto — la quantità si blocca una volta selezionati ",
        SelectSerialstoout: " - Seleziona numeri di serie da uscire",
        Thisinvoicegeneratedusingwwwsimplstockco: "Questa fattura è stata generata usando www.simplstock.co",
        AuthorizedSignature: "Firma autorizzata",
        Invoicesettings: "Impostazioni fattura",
        Draw: "Disegna",
        Taptoselectordeselectitems: "Tocca per selezionare o deselezionare gli elementi",
        Thissignaturewillbeadded: "Questa firma verrà aggiunta in fondo alla tua fattura stampata.",
        SignatureOptions: "Opzioni firma",
        Upload: "Carica",
        DrawSignature: "Disegna firma",
        UploadSignature: "Carica firma",
        Clear: "Cancella",
        ShowStaffName: "nome del personale",
        ShowSKU: "SKU",
        ShowBusinessName: "nome azienda",
        ShowProductName: "nome prodotto",
        ShowBusinessPhoneNumber: "telefono",
        ShowBusinessEmail: "email",
        ShowBusinessAddress: "indirizzo",
        ShowProductImage: "immagine prodotto",
        ShowPaymentDetails: "dettagli di pagamento",
        ShowCategory: "categoria",
        ShowVariant: "variante",
        ShowWarehouse: "magazzino",
        ShowAttributes: "attributi",
        ShowQuantity: "quantità",
        ShowDiscount: "sconto",
        ShowTax: "imposta",
        ShowPrice: "prezzo",
        ShowTotalPrice: "prezzo totale del prodotto",
        ShowExpenses: "spese",
        ShowSignature: "firma",
        ShowNote: "nota",
        showAttachment: "allegato",
        ShowSerialNumber: "numero di serie",
        Invoicesettingsapplied: "Impostazioni fattura applicate. Controlla la fattura per le modifiche.",
        EnterSerialNumber: "Inserisci numero di serie",
    },
    FewLocal: {
        SelectBin: "Seleziona Bin",
        Live: "Live",
        Monitorinventorystocklevels: "Monitora inventario, movimenti e livelli di stock",
        StockControlCentre: "Centro di Controllo Stock",
        Nochartdataavailable: "Nessun dato grafico disponibile",
        Disabled: "Disabilitato",
        Enabled: "Abilitato"
    },
    Bin: {
        Bin: "Bin",
        Add: "Aggiungi",
        NoBinsAddedYet: "Nessun bin aggiunto ancora",
        BinLocationsHelp: "Le posizioni dei bin ti aiutano a tracciare lo stock per posizione esatta all'interno di questo magazzino — niente più ricerche.",
        NameThemByPosition: "Nominale per posizione:",
        AddBinLocation: "Aggiungi posizione bin",
        BinLocations: "posizioni bin",
        BinNameRequired: "Il nome del bin è obbligatorio",
        EditBin: "Modifica bin",
        AddBin: "Aggiungi bin",
        EnterBinName: "Nome bin",
        EnterBinNamePlaceholder: "Inserisci nome bin",
        BinStatus: "Stato bin",
        BinNotes: "Note",
        EnterBinNotesPlaceholder: "Aggiungi alcune note...",
        ViewInventory: "Visualizza inventario",
        Inventory: "Inventario",
        TrymatchingadifferentSKUname: "Prova con un SKU o nome diverso.",
        Thisbinlocationcurrentlyempty: "Questa posizione bin è attualmente vuota.",
        Loadingbins: "Caricamento bin...",
        bins: "bin",
        ManageBin: "Gestisci Bin",
        Print: "Stampa",
        SBin: "Bin Origine",
        DBin: "Bin Destinazione"
    },
    WarehouseExcel: {
        title: "Carica Magazzini & Posizioni Bin",
        description: "Segui i passaggi seguenti per creare in massa magazzini insieme alle loro posizioni bin utilizzando un file Excel.",
        bulkUploadGuide: "Guida al Caricamento Massivo",
        step1: "Passo 1",
        downloadTemplate: "Scarica il template Excel",
        downloadTemplateDesc: "Scarica il template ufficiale con tutti gli header delle colonne richiesti. Non rinominare o rimuovere alcuna colonna.",
        downloadTemplateBtn: "Scarica Template",
        step2: "Passo 2",
        fillExcelFile: "Compila il file Excel",
        fillExcelDesc: "Ogni riga rappresenta un magazzino. Compila tutte le colonne — per le posizioni bin, inserisci tutti i nomi separati da virgola nella colonna <code>Bin Names</code>.",
        step3: "Passo 3",
        thingsToKeepInMind: "Cose da tenere a mente",
        rulesDesc: "Prima di caricare, assicurati che il tuo file rispetti queste regole per evitare errori.",
        step4: "Passo 4",
        uploadYourFile: "Carica il tuo file",
        uploadDesc: "Una volta compilato, carica il file qui sotto. Il sistema creerà automaticamente tutti i magazzini e le posizioni bin.",
        rules: ["Una riga per magazzino", "Nomi bin separati da virgola in una singola cella", "Non rinominare gli header delle colonne", "I nomi bin duplicati per magazzino vengono saltati", "Numero di telefono con prefisso internazionale", "Solo file .xlsx o .xls accettati"],
        dropFileHere: "Trascina qui il tuo file Excel",
        supports: "Supporta .xlsx e .xls — massimo 10 MB",
        chooseFileUpload: "Scegli File & Carica",
        parsing: "Analisi del file in corso...",
        invalidFileType: "Tipo di file non valido. Carica un file Excel.",
        noData: "Nessun dato trovato nell'Excel",
        failedToRead: "Impossibile leggere il file Excel",
        unableToRead: "Impossibile leggere il file.",
        reviewTitle: "Rivedi i dati dei magazzini",
        reviewSubtitle: "Controllo finale prima dell'importazione nel tuo business.",
        changeFile: "Cambia File",
        rowsFound: "righe trovate nel file",
        cancel: "Annulla",
        finalizeImport: "Finalizza & Importa",
        importing: "Importazione in corso...",
        success: "Successo",
        allWarehouseUploadedSuccess: "Tutti i magazzini caricati con successo",
        failed: "Fallito",
        bulkUploadFailed: "Caricamento massivo fallito",
        error: "Errore",
        binNamesNote: "Nella colonna <strong>Bin Names</strong>, inserisci tutte le posizioni bin per un magazzino in un'unica cella, separate da virgole — es: A1, A2, B1, RACK-01.",
        headers: { warehouseName: "Nome Magazzino", email: "Email", phoneNumber: "Numero di Telefono", location: "Posizione", binNames: "Nomi Bin" }
    },
    VariantTemplate: {
        VariantTemplates: "Template Varianti",
        Managereusablevariantpatterns: "Gestisci modelli di varianti riutilizzabili",
        BinTransferHistory: "Cronologia Trasferimenti Bin",
        Trackmovementsacrossbins: "Traccia i movimenti tra i bin",
        SerialNumberHistory: "Cronologia Numeri di Serie",
        Trackproductserialnumberactivity: "Traccia l'attività dei numeri di serie del prodotto",
        Period: "Periodo",
        Nohistoryfound: "Nessuna cronologia trovata",
        Searchserialnumbers: "Cerca numeri di serie...",
        SerialNumbersHistory: "Cronologia Numeri di Serie",
        Serialnumberhistoryglance: "Cronologia numeri di serie a colpo d'occhio.",
        Noserialnumbersfound: "Nessun numero di serie trovato",
        Noactivityhistoryfound: "Nessuna cronologia attività trovata",
        Statussetto: "Stato impostato su",
        Timeline: "Timeline",
        Managereusableproductvariantpatterns: "Gestisci modelli di varianti prodotto riutilizzabili.",
        DeleteTemplate: "Elimina Template",
        Areyousureyouwanttemplate: "Sei sicuro di voler eliminare questo template?",
        CreateNewTemplate: "Crea Nuovo Template",
        CreateTemplate: "Crea Template",
        EditTemplate: "Modifica Template",
        UnlimitedTemplates: "Template illimitati",
        CreateAsManyTemplates: "Crea tutti i template di cui hai bisogno — Abbigliamento, Calzature, Elettronica e altro.",
        PickWhileAddingProduct: "Scegli mentre aggiungi un prodotto",
        OpenTemplateLibrary: "Apri la tua libreria di template e seleziona i nomi delle varianti in pochi secondi.",
        MixFromMultipleTemplates: "Mescola da più template",
        SelectFromMultipleTemplates: "Seleziona nomi di varianti da più template per un singolo prodotto — completamente flessibile.",
        EditAnytime: "Modifica in qualsiasi momento",
        RenameTemplatesAnytime: "Rinomina i template, aggiungi o rimuovi nomi di varianti ogni volta che il tuo catalogo cambia.",
        StayConsistent: "Mantieni la coerenza",
        SameVariantNamesAcrossAll: "Stessi nomi di varianti su tutti i prodotti. Niente errori di battitura, niente duplicati, niente supposizioni.",
        BuildOnceUseEverywhere: "Crea una volta, usa ovunque",
        StopReEnteringVariantNames: "Smetti di reinserire gli stessi nomi di varianti per ogni prodotto. Crea un template, assegnagli i nomi delle varianti e riutilizzalo all'istante.",
        Updateexistingvariantcombinations: "Aggiorna combinazioni di varianti esistenti",
        Definenewvariantcombinations: "Definisci nuove combinazioni di varianti",
        TemplateName: "Nome Template",
        AddVariantOptions: "Aggiungi Opzioni Variante",
        SmallMedium: "es. Small, Medium...",
        VariantsList: "Elenco Varianti",
        Nooptionsaddedyet: "Nessuna opzione aggiunta ancora",
        SaveTemplate: "Salva Template",
        egSizesColorsetc: "es. Taglie Maglietta, Colori, ecc.",
        Pleaseentertemplatename: "Inserisci un nome per il template",
        Pleaseaddatleastonevariantoption: "Aggiungi almeno un'opzione di variante",
        Templateupdatedsuccessfully: "Template aggiornato con successo",
        Templatecreatedsuccessfully: "Template creato con successo",
        Failedtosavetemplate: "Salvataggio template fallito",
        Transfer: "Trasferisci",
        Editassignment: "Modifica assegnazione",
        Updateproductdetailsinbin: "Aggiorna dettagli prodotto nel bin",
        Editinginbin: "Modifica in corso nel bin",
        ConfirmUpdate: "Conferma Aggiornamento",
        ConfirmAssign: "Conferma Assegnazione",
        Assignanotherproduct: "Assegna un altro prodotto",
        TransferBin: "Trasferisci Bin",
        SourceBin: "Bin di Origine",
        DestinationBin: "Bin di Destinazione",
        SelectSourceBin: "Seleziona Bin di Origine",
        SelectDestinationBin: "Seleziona Bin di Destinazione",
        Unit: "Unità",
        ManageVariant: "Gestisci Variante",
        CreateSKUvariationsyourproduct: "Crea variazioni SKU per il tuo prodotto",
        Assigningvariationsto: "Assegnazione variazioni a",
        Novariantsaddedyet: "Nessuna variante aggiunta ancora",
        AddedVariants: "Varianti Aggiunte",
        AddVariantsfromTemplate: "Aggiungi Varianti da Template",
        Pickatemplateandselectvariantnames: "Scegli un template e seleziona i nomi delle varianti",
        ChooseaTemplate: "Scegli un Template",
        Selectvariantnamestoadd: "Seleziona nomi varianti da aggiungere",
        SelectatemplatetopickvariantnamesfroYoucanaddfrommultiple: "Seleziona un template per scegliere i nomi delle varianti. Puoi aggiungerne da più template.",
        Loadingtemplates: "Caricamento template...",
        Backtotemplates: "Torna ai template",
        Selectallindividualadd: "Seleziona tutti o singoli nomi di varianti da aggiungere.",
        VariantNames: "Nomi Varianti",
        MediaDescription: "Media e Descrizione",
        Addattachmentsandproductnotes: "Aggiungi allegati e note prodotto",
        ProductMedia: "Media Prodotto"
    },
    AddProductGuide: {
        title: "Aggiungi quantità iniziale dopo il salvataggio",
        description: "I prodotti non hanno un campo quantità qui. Una volta salvato, usa 'Stock In' per registrare il tuo stock iniziale — con pieno controllo su posizione e tracciabilità.",
        steps: {
            quantity: { title: "Quantità", sub: "Imposta conteggio stock iniziale" },
            binLocation: { title: "Posizione Bin", sub: "Corridoio, scaffale, ripiano — es. A-01-03" },
            serialNumbers: { title: "Numeri di serie", sub: "Traccia ogni unità individualmente" },
            warehouse: { title: "Magazzino", sub: "In quale posizione è conservato" },
            batchExpiry: { title: "Lotto / Scadenza", sub: "Raggruppa stock per numero di lotto" }
        },
        actions: { close: "Chiudi" }
    },
    Remainingtranferitems: {
        NoTransferOrdersFound: "Nessun ordine di trasferimento trovato",
        Itemshistory: "Gli articoli che trasferisci tra magazzini appariranno qui per tracciamento e cronologia.",
        CreateTransfer: "Crea Trasferimento"
    },
    ManufactureLocal: {
        TaponproducttoManufacture: "Tocca il prodotto per produrre",
        Selectproductfrombelow: "Seleziona un prodotto dalla lista sottostante",
        SetupANewProduct: "Configura un nuovo prodotto",
        DefineAProductAdditsrawmaterial: "Definisci un prodotto e aggiungi le sue materie prime",
        ManufacturingSetup: "Configurazione produzione",
        Pickproducttodefineitsproductiondetails: "Scegli un prodotto per definire i suoi dettagli di produzione",
        ConfigureManufacturing: "Configura produzione",
        SelectRawMaterial: "Seleziona materia prima",
        NoRawMaterials: "Nessuna materia prima",
        Definecomponentsneededtoproduct: "Definisci i componenti necessari per produrre questo prodotto.",
        NoAdditionalCosts: "Nessun costo aggiuntivo",
        Addlaboroverheadlogisticalcharges: "Aggiungi costi di manodopera, generali o logistici.",
        AddAdditionalCost: "Aggiungi costo aggiuntivo",
        AddCost: "Aggiungi costo",
        TotalPrice: "Prezzo totale",
        SelectCharges: "Seleziona spese",
        EnterEstimatedCost: "Inserisci costo stimato",
        QtyRequried: "Quantità richiesta",
        Manufacturing: "Produzione",
        Outputfinishedgoodsdestination: "Destinazione prodotti finiti",
        Manufacturingquantity: "Quantitativo di produzione",
        Storefinishedgoodsat: "Conserva i prodotti finiti presso",
        Rawmaterials: "Materie prime",
        StockSelection: "Selezione scorte",
        AdditionalCosts: "Costi aggiuntivi",
        Quantityconsume: "Quantità consumata",
        Totalmanufacturingcost: "Costo totale di produzione",
        Sumofrawmaterialcosts: "Somma di tutti i costi delle materie prime",
        CustomManufacturingCharge: "Spesa di produzione personalizzata",
        Addextralikelaboroverheadrepairs: "Aggiungi costi extra come manodopera, spese generali o riparazioni.",
        CalculatedTotal: "Totale calcolato",
        AddRawMaterial: "Aggiungi materia prima",
        ConfigureRawMaterial: "Configura materia prima",
        Thisoutputunit: "Questa è la quantità di base richiesta per unità di output.",
        ChangeProduct: "Cambia prodotto",
        AddtoList: "Aggiungi alla lista",
        ManufacturedSuccessfully: "Prodotto con successo",
        Manufacture: "Produzione",
        EditDeleteHistory: "Cronologia Modifica/Eliminazione",
        ManageOrder: "Gestisci Ordine",
        ManageBatch: "Gestisci lotto",
        Paymentnotavailablehere: "Pagamento non disponibile qui",
        Thisrecordisanorderorderitself: "Questo record proviene da un ordine. Il pagamento può essere registrato solo dall'ordine stesso.",
        Torecorpaymenttheorderthethere: "Per registrare un pagamento, vai all'ordine collegato e usa l'opzione <b>Registra pagamento</b>.",
        GotoOrder: "Vai all'ordine"
    },
    CustomerExcel: {
        title: "Carica Clienti",
        description: "Segui i passaggi seguenti per creare clienti in blocco utilizzando un file Excel.",
        bulkUploadGuide: "Guia al caricamento in blocco",
        step1: "Passaggio 1",
        downloadTemplate: "Scarica il modello Excel",
        downloadTemplateDesc: "Ottieni il modello ufficiale con tutte le intestazioni di colonna richieste.",
        downloadTemplateBtn: "Scarica Modello",
        step2: "Passaggio 2",
        fillExcelFile: "Compila il file Excel",
        fillExcelDesc: "Ogni riga rappresenta un cliente. Compila tutte le colonne come richiesto.",
        step3: "Passaggio 3",
        thingsToKeepInMind: "Cose da tenere a mente",
        rulesDesc: "Prima di caricare, assicurati che il tuo file segua queste regole per evitare errori.",
        step4: "Passaggio 4",
        uploadYourFile: "Carica il tuo file",
        uploadDesc: "Una volta compilato, carica il file qui sotto. Il sistema creerà automaticamente tutti i clienti.",
        rules: [
            "Solo una riga per cliente",
            "Non rinominare le intestazioni delle colonne",
            "Numero di contatto con prefisso internazionale",
            "Sono accettati solo file .xlsx o .xls"
        ],
        dropFileHere: "Trascina qui il tuo file Excel",
        supports: "Supporta .xlsx e .xls — massimo 10 MB",
        chooseFileUpload: "Scegli File e Carica",
        parsing: "Analisi del file...",
        invalidFileType: "Tipo di file non valido. Carica un file Excel.",
        noData: "Nessun dato trovato nell'Excel",
        failedToRead: "Impossibile leggere il file Excel",
        unableToRead: "Impossibile leggere il file.",
        reviewTitle: "Revisiona i Dati dei Clienti",
        reviewSubtitle: "Controllo finale prima di importare nella tua attività.",
        changeFile: "Cambia File",
        rowsFound: "righe trovate nel file",
        cancel: "Annulla",
        finalizeImport: "Finalizza e Importa",
        importing: "Importazione...",
        success: "Successo",
        allCustomerUploadedSuccess: "Tutti i clienti sono stati caricati con successo",
        failed: "Fallito",
        bulkUploadFailed: "Caricamento in blocco fallito",
        error: "Errore",
        headers: {
            customerName: "Nome Cliente",
            phoneNumber: "Contatto",
            address: "Indirizzo",
            note: "Nota"
        }
    },
    SupplierExcel: {
        title: "Carica Fornitori",
        description: "Segui i passaggi seguenti per creare fornitori in blocco utilizzando un file Excel.",
        bulkUploadGuide: "Guia al caricamento in blocco",
        step1: "Passaggio 1",
        downloadTemplate: "Scarica il modello Excel",
        downloadTemplateDesc: "Ottieni il modello ufficiale con tutte le intestazioni di colonna richieste.",
        downloadTemplateBtn: "Scarica Modello",
        step2: "Passaggio 2",
        fillExcelFile: "Compila il file Excel",
        fillExcelDesc: "Ogni riga rappresenta un fornitore. Compila tutte le colonne come richiesto.",
        step3: "Passaggio 3",
        thingsToKeepInMind: "Cose da tenere a mente",
        rulesDesc: "Prima di caricare, assicurati che il tuo file segua queste regole per evitare errori.",
        step4: "Passaggio 4",
        uploadYourFile: "Carica il tuo file",
        uploadDesc: "Una volta compilato, carica il file qui sotto. Il sistema creerà automaticamente tutti i fornitori.",
        rules: [
            "Solo una riga per fornitore",
            "Non rinominare le intestazioni delle colonne",
            "Numero di contatto con prefisso internazionale",
            "Sono accettati solo file .xlsx o .xls"
        ],
        dropFileHere: "Trascina qui il tuo file Excel",
        supports: "Supporta .xlsx e .xls — massimo 10 MB",
        chooseFileUpload: "Scegli File e Carica",
        parsing: "Analisi del file...",
        invalidFileType: "Tipo di file non valido. Carica un file Excel.",
        noData: "Nessun dato trovato nell'Excel",
        failedToRead: "Impossibile leggere il file Excel",
        unableToRead: "Impossibile leggere il file.",
        reviewTitle: "Revisiona i Dati dei Fornitori",
        reviewSubtitle: "Controllo finale prima di importare nella tua attività.",
        changeFile: "Cambia File",
        rowsFound: "righe trovate nel file",
        cancel: "Annulla",
        finalizeImport: "Finalizza e Importa",
        importing: "Importazione...",
        success: "Successo",
        allSupplierUploadedSuccess: "Tutti i fornitori sono stati caricati con successo",
        failed: "Fallito",
        bulkUploadFailed: "Caricamento in blocco fallito",
        error: "Errore",
        headers: {
            supplierName: "Nome Fornitore",
            phoneNumber: "Contatto",
            bankName: "Nome Banca",
            accountHolderName: "Nome Titolare",
            accountNumber: "Numero Conto",
            note: "Nota"
        }
    },
    ReplaceReturnLocal: {
        ReplacedWith: "Sostituito con",
        Noreplacementhistoryfound: "Nessuna cronologia di sostituzione trovata",
        Noreturnhistoryfound: "Nessuna cronologia di reso trovata",
        Productbeingreturned: "Prodotto in fase di reso",
        Required: "Obbligatorio",
        Selectreturnedproduct: "Seleziona prodotto reso",
        Searchnamescanbarcode: "Cerca per nome, SKU o scansiona codice a barre",
        Browse: "Sfoglia",
        Stockhandling: "Gestione carico a magazzino",
        Stockinreturnedproduct: "Carica a magazzino prodotto reso",
        Ontoinventory: "Sì — l'articolo reso verrà aggiunto nuovamente all'inventario",
        Offreturnedonly: "No — l'articolo verrà registrato solo come reso",
        Usedrestock: "Utilizzato per calcolare la rettifica del profitto al ripristino delle scorte",
        Willaddedbackconfirmation: "Verrà aggiunto nuovamente all'inventario alla conferma",
        Returnreason: "Motivo del reso",
        Optional: "Opzionale",
        SelectReason: "Seleziona motivo",
        Additionalnotes: "Note aggiuntive",
        Describeofcustomerexplanation: "Descrivi le condizioni dell'articolo reso, eventuali danni visibili, spiegazione del cliente...",
        Requiredmustfilledcontinue: "I campi obbligatori devono essere compilati per continuare",
        Reviewdetailsbeforeconfirming: "Rivedi i dettagli prima di confermare",
        Replacementproductwilldeductedinventoryconfirmation: "Il prodotto sostitutivo verrà scaricato dall'inventario alla conferma.",
        Choosereplacementproduct: "Scegli prodotto sostitutivo",
        Willdeductedfrominventoryconfirm: "Verrà scaricato dall'inventario alla conferma",
        Thesewillattachedothereturnrecord: "Queste immagini saranno allegate al registro del reso",
        Replacementitem: "Articolo sostitutivo",
        Addanotherproduct: "Aggiungi un altro prodotto",
        Replacementproductwillbe: "Il prodotto sostitutivo verrà",
        deducted: "scaricato",
        fromyourinventoryconfirmation: "dall'inventario alla conferma.",
        productadjustedusingprice: "Il prodotto reso verrà reintegrato e il profitto rettificato utilizzando il prezzo di vendita originale.",
        Willloggedreturnedonlynotrestocked: "Verrà registrato solo come reso — non reintegrato",
        Returnonly: "Solo reso",
        Imagesofreturnedproduct: "Immagini del prodotto reso",
        Returnedproductwill: "Il prodotto reso",
        not: "non",
        berestockedloggedreturnedonly: "verrà reintegrato — registrato solo come reso.",
        AddImage: "Aggiungi immagine",
        STOCKIN: "CARICO",
        LOGONLY: "SOLO REGISTRO",
        ContinuetoReview: "Continua alla Revisione →",
        Confirmreplacement: "Conferma sostituzione",
        Confirmreturn: "Conferma reso",
        Filldetailsbelowproceed: "Compila i dettagli di seguito per procedere",
        Review: "Revisione",
        editdetails: "Modifica dettagli",
        Configurereturndetails: "Configura dettagli reso",
        Configurereplacementdetails: "Configura dettagli sostituzione",
        SelectSource: "Seleziona Origine",
        Returning: "Reso in corso",
        Replacement: "Sostituzione",
        WalkCustomer: "Cliente occasionale",
        RETURNEDPRODUCT: "PRODOTTO RESO",
        REPLACEMENTPRODUCT: "PRODOTTO SOSTITUTIVO",
        STOCKOUT: "USCITA MAGAZZINO",
        Netinventoryimpact: "Impatto netto inventario",
        Replacementitemcost: "Costo articolo sostitutivo",
        Returneditemrestockvalue: "Valore ripristino articolo reso",
        PROFITINVENTORYSUMMARY: "RIEPILOGO PROFITTO E INVENTARIO",
        Inventoryaction: "Azione inventario",
        Valuededucted: "Valore detratto",
        Profitadjustment: "Rettifica profitto",
        stockedout: " scaricato",
        restocked: " reintegrato",
        Noaction: "Nessuna azione",
        Valuebeingreturned: "Valore reso",
        Willberestocked: "Verrà reintegrato",
        Willbe: "Verrà",
        logged: "registrato",
        ON: "ACCESO",
        OFF: "SPENTO",
        Linked: "Collegato",
        Pleaseselectreturnedproduct: "Seleziona un prodotto restituito",
        Quantityrequired: "La quantità è obbligatoria",
        Buyingpricerequired: "Il prezzo d'acquisto è obbligatorio",
        Pleaseaddleastreplacementproduct: "Aggiungi almeno un prodotto di sostituzione",
        Pleaseconfigurereturnedproductdetails: "Configura i dettagli del prodotto restituito",
        Pleaseselectcustomer: "Seleziona un cliente",
        Returndateisrequired: "La data di reso è obbligatoria",
        Pleasefillallrequiredfields: "Compila tutti i campi obbligatori",
        Wildeductedfrominventory: "Verrà detratto dall'inventario",
        Currentprice: "Prezzo attuale",
        Defectivedamaged: "Difettoso / danneggiato",
        Wrongitemreceived: "Articolo errato ricevuto",
        Customerchangedmind: "Il cliente ha cambiato idea",
        Sizefitissue: "Problema di taglia / vestibilità",
        Notasdescribed: "Non come descritto",
        Other: "Altro",
        Originalsaleprice: "Prezzo di vendita originale (profitto adj.)",
        Addedbackinventory: "Riaggiunto all'inventario",
        Notaddedinventory: "Non aggiunto all'inventario",
        replacedwith: "sostituito con",
        deductedfrominventory: "dedotto dall'inventario",
        RETURNWITHSTOCKIN: "RESO · CON STOCK-IN",
        RETURNNOSTOCKIN: "RESO · SENZA STOCK-IN",
        MULTIPLEREPLACEMENTS: "SOSTITUZIONI MULTIPLE",
        SINGLEREPLACEMENT: "SOSTITUZIONE SINGOLA",
        InternalTrackingRecordInfo: "This is a record for internal tracking. This process DOES NOT automatically update or delete related invoices, orders, or accounts.",
        ManualStepsIfNeeded: "Manual Steps (if needed):",
        ManualStep1: "Return/Delete invoice from Sale History",
        ManualStep2: "Adjust customer ledger manually",
        ManualStep3: "Update related purchase record",
        RETURNEDSTOCKIN: "RESO · STOCK IN",
        REPLACEMENTSTOCKOUT: "SOSTITUZIONE · STOCK OUT",
        Returnonlylogsthisentry: "Il reso registra solo questa voce —",
        nostockwillbeaddedorremoved: "nessuna scorta verrà aggiunta o rimossa",
        frominventory: "dall'inventario.",
        Whentousethis: "Quando usare questa opzione:",
        UseReturnenddayrecorditemsoutsalesthatcamebackunusablewantinventory: "Usa Reso a fine giornata per registrare gli articoli spediti per la vendita che sono tornati danneggiati o inutilizabili — articoli che desideri tracciare ma che non puoi aggiungere nuovamente all'inventario.",
        Youcanviewallpastreturnentriesin: "Puoi visualizzare tutti i resi passati in",
        ReturnHistory: "Cronologia resi",
        underthe: "sotto la scheda",
        Others: "Altri",
        tab: ".",
        Negativestocktransactiondisabled: "Le transazioni azionarie negative sono disabilitate."
    },
    NewRLocal: {
        Originalsaleprice: "Prezzo di vendita originale",
        Editinghistoryonlyinventorystaysunchanged: "Modifica solo della cronologia — l'inventario rimane invariato.",
        Changeshereupdatethisdetailsquantitiesaffected: "Le modifiche qui aggiornano solo i dettagli di questo record (motivo, data, note). Le quantità effettive di stock, le posizioni dei bin e i dati dei prodotti non vengono influenzati.",
        Needtofixinventorylevelsinstead: "Devi correggere i livelli di inventario?",
        AdjustStock: "Rettifica Stock",
        Refund: "Rimborsare",
        ImportantNote: "Nota Importante",
        Pleasereviewbeforecontinuing: "Si prega di rivedere prima di continuare",
        Onceshippedreceivedanyupdatesmadeorder: "Una volta che un ordine è stato spedito o ricevuto, eventuali aggiornamenti apportati all'ordine non si rifletteranno nella cronologia delle transazioni.",
        Thisundone: "Questo rimuoverà permanentemente l'ordine. Questa azione non può essere annullata.",
        Inventorywilladjustedautomatically: "L'inventario non verrà rettificato automaticamente",
        Deletingthisreversevedshippedyouwillneed: "L'eliminazione di questo non inverte alcuna modifica allo stock. Se gli articoli sono già stati ricevuti/spediti, dovrai",
        reflectthecorrectstocklevels: "per riflettere i livelli di stock corretti.",
        manuallyadjustyourinventory: "regolare manualmente il tuo inventario",
        Addremovestockforitemsthatwereshipped: "Aggiungi/rimuovi stock per articoli che sono stati spediti",
        Addremovestockforitemsthatwerereceived: "Aggiungi/rimuovi stock per articoli che sono stati ricevuti",
        Updatecostrecordspaymentwaalreadymade: "Aggiorna i record dei costi se il pagamento è già stato effettuato",
        Reconcilerecordsandoutstandingpayments: "Riconcilia i record e i pagamenti in sospeso"
    },
    ReceivablesLocal: {
        Receivables: "Crediti",
        Manageandtrackcustomerduebalances: "Gestisci e traccia i saldi dovuti dai clienti",
        Viewcustomerduebalancereport: "Visualizza report saldo clienti dovuti",
        Viewsupplierduebalancereport: "Visualizza report saldo fornitori dovuti",
        DueBalance: "Saldo Dovuto",
        Unpaid: "Non Pagato",
        PartiallyPaid: "Parzialmente Pagato",
        Paid: "Pagato",
        HighestBalance: "Saldo Più Alto",
        LowestBalance: "Saldo Più Basso",
        Filldetailsrecordpayment: "Compila i dettagli per registrare il pagamento",
        NewPaymentEntry: "Nuova Voce di Pagamento",
        EditPaymentEntry: "Modifica Voce di Pagamento",
        Nosuppliersfound: "Nessun fornitore trovato",
        Nocustomersfound: "Nessun cliente trovato",
        LowtoHigh: "Dal Basso all'Alto",
        HightoLow: "Dall'Alto al Basso",
        AttachmentUploadedSc: "Allegato caricato con successo",
        AttachmentUploadedF: "Caricamento dell'allegato fallito",
        Pay: "Paga",
        NoBillsFound: "Nessuna Fattura Trovata",
        Thiscustomerhasunpaidbills: "Questo cliente non ha fatture non pagate.",
        TotalDue: "Totale Dovuto",
        BillsFound: "Fatture Trovate",
        DeselectAll: "Deseleziona Tutto",
        SelectAll: "Seleziona Tutto",
        ShowDetails: "Mostra dettagli"
    },
    AssetsNewLocal: {
        Assignedon: "Assegnato il",
        Total: "Totale",
        Assigned: "Assegnato",
        Remaining: "Rimanente",
        Available: "Disponibile",
        NoSerialNumbers: "Nessun numero di serie",
        UpdateExistingAssetDetails: "Aggiorna dettagli risorsa esistente",
        RegisterNewBusinessAsset: "Registra nuova risorsa aziendale",
        BasicInformation: "Informazioni di base",
        AssetDetails: "Dettagli risorsa",
        Quantity: "Quantità",
        SerialNumbers: "Numeri di serie",
        SerialNumberPlaceholder: "Numero di serie",
        AddSerialNumber: "Aggiungi numero di serie",
        SerialNumbersOptional: "I numeri di serie sono opzionali. Puoi aggiungere fino a",
        AssetImages: "Immagini risorsa",
        AdditionalNotes: "Note aggiuntive",
        AdditionalNotesPlaceholder: "Ulteriori dettagli o cronologia delle manutenzioni...",
        Updating: "Aggiornamento...",
        Adding: "Aggiunta...",
        ITEquipmentPlaceholder: "es. Apparecchiature informatiche",
        LoadingMoreActivities: "Caricamento di altre attività...",
        AssignedAssets: "Beni Assegnati",
        Noassetsassignedstaffmember: "Nessun bene assegnato a questo membro dello staff.",
        Assignassetstaff: "Assegna un bene al personale",
        Returnassetfromstaff: "Restituisci questo bene dal personale",
        AssignmentDetails: "Dettagli Assegnazione",
        Serial: "Seriale",
        ViewAssets: "Visualizza Tutti i Beni",
        ViewByStaff: "Visualizza per Personale",
        AssignedHistory: "Cronologia Assegnazioni",
        Returned: "Restituito",
        Returnedon: "Restituito il",
        ReturnedBy: "Restituito da",
        AssignedTo: "Assegnato a",
        NoHistoryRecords: "Nessun record di cronologia",
        Selectstaffmemberviewtheirassets: "Seleziona un membro del personale per visualizzare i suoi beni.",
        Deleted: "ELIMINATO",
        searchPlaceholder: "Cerca risorsa per nome o numero di serie..."
    },
    InventoryCountLocale: {
        InventoryCount: "Conteggio Inventario",
        Viewinventorycountreport: "Visualizza report conteggio inventario",
        ItemsCount: "Conteggio Articoli",
        All: "Tutti",
        InProgress: "In Corso",
        Submitted: "Inviato",
        awaitingreview: "In Attesa di Revisione",
        EditInventoryCount: "Modifica Conteggio Inventario",
        NewInventoryCount: "Nuovo Conteggio Inventario",
        Modifyinventorycountsheetdetails: "Modifica dettagli foglio conteggio",
        Startanewinventorycountsheet: "Avvia nuovo foglio conteggio",
        GeneralInformation: "Informazioni Generali",
        Title: "Titolo",
        SaveChanges: "Salva Modifiche",
        Selectproductsforthisinventorycountsheet: "Seleziona prodotti per questo foglio",
        InventoryCountDetails: "Dettagli Conteggio Inventario",
        Inventorycountsheetdetails: "Dettagli foglio conteggio",
        Viewingdetailsforcountsheet: "Visualizzazione dettagli foglio conteggio",
        Started: "Iniziato",
        TaskSheets: "Fogli Attività",
        Allitems: "Tutti gli articoli",
        NotStarted: "Non Iniziato",
        Completed: "Completato",
        Results: "Risultati",
        ViewResults: "Visualizza Risultati",
        DeleteInventoryCount: "Elimina Conteggio Inventario",
        Viewingtransactionandadjustments: "Visualizzazione log transazioni e rettifiche stock",
        Productsadjusted: "Prodotti rettificati",
        Assignee: "Assegnato a",
        Tasksheetdetails: "Dettagli foglio attività",
        Draft: "Bozza",
        VariantQuantities: "Quantità Varianti",
        AssignedProducts: "Prodotti Assegnati",
        ReturnAsset: "Restituisci Bene",
        EditTasksheet: "Modifica Foglio Attività",
        NewTasksheet: "Nuovo Foglio Attività",
        Updatetasksheetdetails: "Aggiorna dettagli foglio attività",
        Starttasksheetforthisinventorycount: "Avvia nuovo foglio attività per questo conteggio",
        TaskSheetInformation: "Informazioni Foglio Attività",
        SheetTitle: "Titolo Foglio",
        Entersheettitle: "Inserisci titolo foglio",
        SubmissionResult: "Risultato Invio",
        ReviewChanges: "Revisiona Modifiche",
        Viewingsubmissionresultsforthisinventorycount: "Visualizzazione risultati di invio per questo conteggio",
        Reviewyourinventorycountbeforesubmitting: "Rivedi il conteggio inventario prima di inviare"
    },
    NewMissingLocale: {
        Failedtoloadcounts: "Impossibile caricare i conteggi",
        NoInventoryCounts: "Nessun Conteggio Inventario",
        NoMatches: "Nessuna Corrispondenza",
        Therearenoinventorycountswiththestatus: "Non ci sono conteggi inventario con lo stato",
        Noinventorycountsfoundyoursearchterm: "Nessun conteggio inventario trovato corrispondente al termine di ricerca.",
        Thereareinventorycountsrecordedyetforthisbusiness: "Non ci sono ancora conteggi inventario registrati per questa azienda."
    },
    StockinModalP: {
        StockInNow: "Inserisci Stock Ora",
        Settheopeningquantityforthisproductrightnow: "Imposta la quantità iniziale per questo prodotto ora.",
        Addinitialstock: "Aggiungere stock iniziale?",
        dothislater: "Lo farò più tardi",
        Productadded: "Prodotto aggiunto!",
        isready: "è pronto.",
        SeeHowItWorks: "Vedi Come Funziona",
        NoSalesOrdersFound: "Nessun Ordine di Vendita Trovato",
        NoPurchaseOrdersFound: "Nessun Ordine di Acquisto Trovato",
        Startcreatingoutgoinginventoryrevenue: "Inizia a creare ordini di vendita per tracciare l'inventario in uscita e i ricavi.",
        Trackrestockssupplierplace: "Traccia i rifornimenti di inventario e gli ordini dei fornitori in un unico posto.",
        CreateSalesOrder: "Crea Ordine di Vendita",
        CreatePurchaseOrder: "Crea Ordine di Acquisto",
    }
    ,
    dialy_report: "Report Movimento Giornaliero",
    Quotation: "Preventivo",
    Quote: "Preventivo",
    Assignee: "Assegnato a",
    dayStart: "Inizio giornata",

    ShowTotalAmount: "Importo Totale",


    tutorial: {
        watchTitle: 'Guarda i tutorial passo-passo',
        watchDesc: 'Scopri SimplyStock sul nostro canale YouTube',
        modalTitle: 'Stai al passo con SimplyStock',
        modalDesc: 'Iscriviti per ottenere nuovi tutorial nel momento in cui vengono rilasciati',
        feature1Title: 'Scenari delle nuove funzionalità',
        feature1Sub: 'Ogni nuovo aggiornamento spiegato con un breve video, in modo da non perdere mai le novità',
        feature2Title: 'Video dimostrativi rapidi',
        feature2Sub: 'Configura stock, fatture, accesso al personale e altro in meno di 5 minuti',
        feature3Title: 'Notifiche istantanee',
        feature3Sub: 'Ricevi una notifica nel momento in cui un nuovo tutorial è attivo: impara al tuo ritmo',
        feature4Title: '100% gratis, sempre',
        feature4Sub: 'Tutti i tutorial sono gratuiti per sempre — non è necessario alcun accesso o abbonamento',
        subscribeBtn: 'Iscriviti a SimplyStock',
        maybeLater: 'Magari dopo'
    }
    ,
    dailyCashReport: {
        "title": "Rapporto Cassa Giornaliero",
        "subtitle": "Chi ha pagato cosa, in quale data e cosa è ancora dovuto — raggruppato dal Dettaglio Vendite.",
        "totalSales": "Vendite totali",
        "cashReceived": "Contanti Ricevuti",
        "outstanding": "In sospeso",
        "collectionRate": "Tasso di riscossione",
        "grandTotalAllDates": "TOTALE GENERALE (tutte le date)",
        "totalLabel": "Totale",
        "loading": "Caricamento...",
        "noData": "Nessun dato trovato per l'intervallo di date selezionato.",
        "loadingMore": "Caricamento altro..."
    },
    dailyCashReportColumns: {
        "date": "Data",
        "customer": "Cliente",
        "productsSold": "Prodotti Venduti",
        "products": "Prodotti",
        "salesAmount": "Importo Vendite",
        "sales": "Vendite",
        "received": "Totale Ricevuto",
        "receivedShort": "Ricevuto",
        "debited": "Addebitato a Libro Mastro",
        "due": "Dovuto",
        "paymentModes": "Modalità di Pagamento",
        "mode": "Modalità"
    }
}

export default it
